import { ShufflerFilterData } from './filters.types';

const CardsFilters: { [key: string]: ShufflerFilterData } = {
  Cards: {
    searchText: 'Search by Product Name or Occasion',
    searchParams: ['name', 'uid'],
    searchFilters: ['collections'],
    detailFilters: ['size', 'format', 'orientation'],
    detailContrast: false,
    optionGroups: ['Foil Color', 'Paper Surface', 'Envelopes', 'Corners'],
    featured: [
      'P1218_57Ph',
      'P1218_57P',
      'P1218_57F_H',
      'P1218_57F_V',
      'P1218_55TF',
      'P1218_455Ph',
      'P1218_455Pv',
      'P1218_455F_H',
      'P1218_455F_V',
      'P1218_455A4v',
    ],
    filters: [
      {
        groupname: 'category',
        groupLabel: 'Category',
        groupfilters: [
          {
            name: 'Press Printed Cards',
            description: 'Create the perfect Classic Press Printed card.',
            products: [],
          },
          {
            name: 'Foil Cards',
            description: 'Create the perfect Foil Stamped card.',
            products: [],
          },
          {
            name: 'Creative Edge Cards',
            description: 'Create the perfect Creative Edge Die-Cut card.',
            products: [],
          },
          {
            name: 'Photo Paper Cards',
            description: '',
            products: [],
          },
        ],
      },
      {
        groupname: 'collections',
        groupLabel: 'Collections',
        groupfilters: [
          {
            name: 'Graduation',
            description: 'Graduation announcements for School Seniors and students.',
            default: true,
            products: [
              'WOS_P57P_540h',
              'WOS_P57P_540v',
              'WOS_P57P_542h',
              'WOS_P57P_542v',
              'WOS_P57P_544h',
              'WOS_P57P_544v',
              'WOS_P57P_546h',
              'WOS_P57P_546v',
              'WOS_P57P_548h',
              'WOS_P57P_548v',
              'WOS_P57P_550h',
              'WOS_P57P_550v',
              'WOS_P57P_552h',
              'WOS_P57P_552v',
              'WOS_P57P_554h',
              'WOS_P57P_554v',
              'WOS_P57P_556h',
              'WOS_P57P_556v',
              'WOS_P57P_560h',
              'WOS_P57P_560v',
              'WOS_P57P_562h',
              'WOS_P57P_562v',
              'WOS_P57P_564h',
              'WOS_P57P_564v',
              'WOS_P57P_566h',
              'WOS_P57P_566v',
              'WOS_P57P_568h_22',
              'WOS_P57P_568v_22',
              'WOS_P57F_540h',
              'WOS_P57F_540v',
              'WOS_P57F_542h',
              'WOS_P57F_542v',
              'WOS_P57F_544h',
              'WOS_P57F_544v',
              'WOS_P57F_546h',
              'WOS_P57F_546v',
              'WOS_P57F_548h',
              'WOS_P57F_548v',
              'WOS_P57F_550h',
              'WOS_P57F_550v',
              'WOS_P57F_552h',
              'WOS_P57F_552v',
              'WOS_P57F_554h',
              'WOS_P57F_554v',
              'WOS_P57F_556h',
              'WOS_P57F_556v',
              'WOS_P57F_560h',
              'WOS_P57F_560v',
              'WOS_P57F_562h',
              'WOS_P57F_562v',
              'WOS_P57F_564h',
              'WOS_P57F_564v',
              'WOS_P57F_566h',
              'WOS_P57F_566v',
              'WOS_P57F_568h',
              'WOS_P57F_568v',
            ],
          },
          {
            name: 'Happy Holidays',
            description: 'Say Happy Holidays with these festive cards',
            products: [
              'WOS_P57P_F192h',
              'WOS_P57P_F192v',
              'WOS_P455P_F192h',
              'WOS_P455P_F192v',
              'WOS_P57F_F192h',
              'WOS_P57F_F192v',
              'WOS_P455F_F192h',
              'WOS_P455F_F192v',
              'WOS_P55T_F192',
              'WOS_P455A_F192',
              'WOS_P57P_F238h',
              'WOS_P57P_F238v',
              'WOS_P455P_F238h',
              'WOS_P455P_F238v',
              'WOS_P57F_F238h',
              'WOS_P57F_F238v',
              'WOS_P455F_F238h',
              'WOS_P455F_F238v',
              'WOS_P55T_F238',
              'WOS_P455A_F238',
              'WOS_P57P_F246h',
              'WOS_P57P_F246v',
              'WOS_P455P_F246h',
              'WOS_P455P_F246v',
              'WOS_P57F_F246h',
              'WOS_P57F_F246v',
              'WOS_P455F_F246h',
              'WOS_P455F_F246v',
              'WOS_P55T_F246',
              'WOS_P455A_F246',
              'P57P_250h',
              'P57P_250v',
              'P455P_250h',
              'P455P_250v',
              'P57F_250h',
              'P57F_250v',
              'P455F_250h',
              'P455F_250v',
              'P55T_250',
              'P455A_250',
              'P57P_252h',
              'P57P_252v',
              'P455P_252h',
              'P455P_252v',
              'P57F_252h',
              'P57F_252v',
              'P455F_252h',
              'P455F_252v',
              'P55T_252',
              'P455A_252',
              'P57P_256h',
              'P57P_256v',
              'P455P_256h',
              'P455P_256v',
              'P57F_256h',
              'P57F_256v',
              'P455F_256h',
              'P455F_256v',
              'P55T_256',
              'P455A_256',
              'P57P_258h',
              'P57P_258v',
              'P455P_258h',
              'P455P_258v',
              'P57F_258h',
              'P57F_258v',
              'P455F_258h',
              'P455F_258v',
              'P55T_258',
              'P455A_258',
              'P57P_260h',
              'P57P_260v',
              'P455P_260h',
              'P455P_260v',
              'P57F_260h',
              'P57F_260v',
              'P455F_260h',
              'P455F_260v',
              'P55T_260',
              'P455A_260',
              'P57P_272h',
              'P57P_272v',
              'P455P_272h',
              'P455P_272v',
              'P57F_272h',
              'P57F_272v',
              'P455F_272h',
              'P455F_272v',
              'P55T_272',
              'P455A_272',
              'WOS_P455P_F192h',
              'WOS_P455P_F192v',
              'WOS_P455P_F238h',
              'WOS_P455P_F238v',
              'WOS_P57P_576ah',
              'WOS_P57P_576bh',
              'WOS_P57P_578ah',
              'WOS_P57P_580eh',
              'WOS_P57P_582ah',
              'WOS_P57P_588bh',
              'WOS_P57P_592bv',
              'WOS_P57P_594bv',
              'WOS_P57P_598ah',
              'WOS_P57P_604dh',
              'WOS_P57P_612cv',
              'WOS_P57P_614cv',
              'WOS_P57P_616dv',
              'WOS_P57F_578ahh',
              'WOS_P57F_578-2ahh',
              'WOS_P57F_580ehh',
              'WOS_P57F_582-ahh',
              'WOS_P57F_582-2ahh',
              'WOS_P57F_588bhh',
              'WOS_P57F_588-2bhh',
              'WOS_P57F_592bv',
              'WOS_P57F_592-2bv',
              'WOS_P57F_594bv',
              'WOS_P57F_594-2bv',
              'WOS_P57F_598ahh',
              'WOS_P57F_598-2ahh',
              'WOS_P57F_604dhh',
              'WOS_P57F_604-2dhh',
              'WOS_P57F_612cv',
              'WOS_P57F_612-2cv',
              'WOS_P57F_614cv',
              'WOS_P57F_614-2cv',
              'WOS_P57F_616dv',
              'WOS_P57F_616-2dv',
            ],
          },
          {
            name: 'Seasons Greetings',
            description: 'Send your best for the season!',
            products: [
              'WOS_P57P_F178h',
              'WOS_P57P_F178v',
              'WOS_P57P_F186h',
              'WOS_P57P_F186v',
              'WOS_P57P_F190h',
              'WOS_P57P_F190v',
              'WOS_P455P_F178h',
              'WOS_P455P_F178v',
              'WOS_P455P_F186h',
              'WOS_P455P_F186v',
              'WOS_P455P_F190h',
              'WOS_P455P_F190v',
              'WOS_P57F_F178h',
              'WOS_P57F_F178v',
              'WOS_P57F_F186h',
              'WOS_P57F_F186v',
              'WOS_P57F_F190h',
              'WOS_P57F_F190v',
              'WOS_P57F_F242h',
              'WOS_P57F_F242v',
              'WOS_P455F_F178h',
              'WOS_P455F_F178v',
              'WOS_P455F_F186h',
              'WOS_P455F_F186v',
              'WOS_P455F_F190h',
              'WOS_P455F_F190v',
              'WOS_P455F_F242h',
              'WOS_P455F_F242v',
              'WOS_P55T_F178',
              'WOS_P55T_F186',
              'WOS_P55T_F190',
              'WOS_P55T_F242',
              'WOS_P455A_F178',
              'WOS_P455A_F186',
              'WOS_P455A_F190',
              'WOS_P455A_F242',
              'P57P_FL003Ph',
              'P57P_FL005Ph',
              'P57P_FL015Pv',
              'WOS_PCE57P_F224h',
              'WOS_PCE57P_F224v',
              'WOS_PCE48P_F202h',
              'WOS_PCE48P_F202v',
              'WOS_PCE57P_F300v',
              'WOS_PCE57P_F308v',
              'WOS_PCE57P_F310v',
              'PCE57P_332v',
              'Y5BB21h-48',
              'Y5BB21v-48',
            ],
          },
          {
            name: 'Christmas',
            description: 'Wish them the Merriest Christmas',
            products: [
              'WOS_P57P_F204h',
              'WOS_P57P_F204v',
              'WOS_P57P_F236h',
              'WOS_P57P_F236v',
              'P57P_264h',
              'P57P_264v',
              'P57P_268h',
              'P57P_268v',
              'P57P_270h',
              'P57P_270v',
              'WOS_P455P_F204h',
              'WOS_P455P_F204v',
              'WOS_P455P_F236h',
              'WOS_P455P_F236v',
              'P455P_264h',
              'P455P_264v',
              'P455P_268h',
              'P455P_268v',
              'P455P_270h',
              'P455P_270v',
              'WOS_P57F_F204h',
              'WOS_P57F_F204v',
              'WOS_P57F_F236h',
              'WOS_P57F_F236v',
              'P57F_270h',
              'P57F_270v',
              'P455F_270h',
              'P455F_270v',
              'P55T_270',
              'P455A_270',
              'WOS_P455F_F204h',
              'WOS_P455F_F204v',
              'WOS_P55T_F204',
              'WOS_P455A_F204',
              'WOS_P455F_F236h',
              'WOS_P455F_F236v',
              'WOS_P55T_F236',
              'WOS_P455A_F236',
              'P57F_264h',
              'P57F_264v',
              'P455F_264h',
              'P455F_264v',
              'P55T_264',
              'P455A_264',
              'P57F_268h',
              'P57F_268v',
              'P455F_268h',
              'P455F_268v',
              'P55T_268',
              'P455A_268',
              'P57P_FL001Ph',
              'P57P_FL002Ph',
              'P57P_FL012Pv',
              'P57P_FL013Pv',
              'PCE57P_340v',
              'PCE57P_340h',
              'WOS_PCE55P_F208',
              'PCE48P_342h',
              'PCE48P_342v',
              'WOS_PCE57P_F302v',
              'WOS_PCE57P_F304v',
              'WOS_PCE57P_F312v',
              'WOS_PCE57P_F318v',
              'PCE57P_330v',
              'Y10BA603h-57',
              'Y10BA603v-57',
              'Y10BA800h-57',
              'Y10BA800v-57',
              'Y13BA455h-57',
              'Y13BA455v-57',
              'Y13BA1295h-57',
              'Y13BA1295v-57',
              'Y17BR009h-57',
              'Y17BR009v-57',
              'Y3BB01h-48',
              'Y3BB01v-48',
              'Y4BB22h-48',
              'Y4BB22v-48',
              'Y5BA125h-48',
              'Y5BA125v-48',
              'Y10BP116h-48',
              'Y10BP116v-48',
              'Y17BR003h-48',
              'Y17BR003v-48',
              'WOS_P57P_576bh',
              'WOS_P57P_578bh',
              'WOS_P57P_580bh',
              'WOS_P57P_588ah',
              'WOS_P57P_588dh',
              'WOS_P57P_590cv',
              'WOS_P57P_592av',
              'WOS_P57P_592cv',
              'WOS_P57P_594av',
              'WOS_P57P_598bh',
              'WOS_P57P_598dh',
              'WOS_P57P_600h',
              'WOS_P57P_604ah',
              'WOS_P57P_604bh',
              'WOS_P57P_610av',
              'WOS_P57P_612av',
              'WOS_P57P_614av',
              'WOS_P57P_616av',
              'WOS_P57F_576bhh',
              'WOS_P57F_576-2bhh',
              'WOS_P57F_578bhh',
              'WOS_P57F_578-2bhh',
              'WOS_P57F_580bhh',
              'WOS_P57F_580-2bhh',
              'WOS_P57F_588ahh',
              'WOS_P57F_588-2ahh',
              'WOS_P57F_588dhh',
              'WOS_P57F_588-2dhh',
              'WOS_P57F_590cv',
              'WOS_P57F_590-2cv',
              'WOS_P57F_592av',
              'WOS_P57F_592-2av',
              'WOS_P57F_592cv',
              'WOS_P57F_592-2cv',
              'WOS_P57F_594av',
              'WOS_P57F_594-2av',
              'WOS_P57F_598bhh',
              'WOS_P57F_598-2bhh',
              'WOS_P57F_598dhh',
              'WOS_P57F_598-2dhh',
              'WOS_P57F_600hh',
              'WOS_P57F_600-2hh',
              'WOS_P57F_604ahh',
              'WOS_P57F_604-2ahh',
              'WOS_P57F_604bhh',
              'WOS_P57F_604-2bhh',
              'WOS_P57F_608hh',
              'WOS_P57F_608-2hh',
              'WOS_P57F_610av',
              'WOS_P57F_610-2av',
              'WOS_P57F_612av',
              'WOS_P57F_612-2av',
              'WOS_P57F_614av',
              'WOS_P57F_614-2av',
              'WOS_P57F_616av',
              'WOS_P57F_616-2av',
            ],
          },
          {
            name: 'Joy',
            description: 'Share some joy!',
            products: [
              'WOS_P57P_F154h',
              'WOS_P57P_F154v',
              'WOS_P455P_F154h',
              'WOS_P455P_F154v',
              'WOS_P57F_F154h',
              'WOS_P57F_F154v',
              'WOS_P455F_F154h',
              'WOS_P455F_F154v',
              'WOS_P55T_F154',
              'WOS_P455A_F154',
              'P57P_254h',
              'P57P_254v',
              'P455P_254h',
              'P455P_254v',
              'P57F_254h',
              'P57F_254v',
              'P455F_254h',
              'P455F_254v',
              'P55T_254',
              'P455A_254',
              'P57P_258h',
              'P57P_258v',
              'P455P_258h',
              'P455P_258v',
              'P57F_258h',
              'P57F_258v',
              'P455F_258h',
              'P455F_258v',
              'P55T_258',
              'P455A_258',
              'P57P_262h',
              'P57P_262v',
              'P455P_262h',
              'P455P_262v',
              'P57F_262h',
              'P57F_262v',
              'P455F_262h',
              'P455F_262v',
              'P55T_262',
              'P455A_262',
              'P57P_266h',
              'P57P_266v',
              'P455P_266h',
              'P455P_266v',
              'P57F_266h',
              'P57F_266v',
              'P455F_266h',
              'P455F_266v',
              'P55T_266',
              'P455A_266',
              'P57P_274h',
              'P57P_274v',
              'P455P_274h',
              'P455P_274v',
              'P57F_274h',
              'P57F_274v',
              'P455F_274h',
              'P455F_274v',
              'P55T_274',
              'P455A_274',
              'P57P_FL007Ph',
              'P57P_FL009Ph',
              'P57P_FL017Pv',
              'WOS_PCE57P_F220h',
              'WOS_PCE48P_F200h',
              'WOS_PCE57P_F220h',
              'PCE57P_332v',
              'Y10BP102h-57',
              'Y10BP102v-57',
              'Y10BA196h-48',
              'Y10BA196v-48',
              'P57P_FL007Ph',
              'P57P_FL017Pv',
              'WOS_P57P_572ch',
              'WOS_P57P_574ah',
              'WOS_P57P_576ch',
              'WOS_P57P_596cv',
              'WOS_P57P_592dv',
              'WOS_P57P_598ah',
              'WOS_P57P_598bh',
              'WOS_P57P_598ch',
              'WOS_P57P_598dh',
              'WOS_P57P_610cv',
              'WOS_P57P_610dv',
              'WOS_P57F_572chh',
              'WOS_P57F_572-2chh',
              'WOS_P57F_574ahh',
              'WOS_P57F_574-2ahh',
              'WOS_P57F_576chh',
              'WOS_P57F_576-2chh',
              'WOS_P57F_596cv',
              'WOS_P57F_596-2cv',
              'WOS_P57F_598ahh',
              'WOS_P57F_598-2ahh',
              'WOS_P57F_598bhh',
              'WOS_P57F_598-2bhh',
              'WOS_P57F_598chh',
              'WOS_P57F_598-2chh',
              'WOS_P57F_598dhh',
              'WOS_P57F_598-2dhh',
              'WOS_P57F_610cv',
              'WOS_P57F_610-2cv',
            ],
          },
          {
            name: 'Merry',
            description: 'Tis the season to be merry!',
            products: [
              'WOS_P57P_F236h',
              'WOS_P57P_F236v',
              'WOS_P455P_F236h',
              'WOS_P455P_F236v',
              'WOS_P57F_F236h',
              'WOS_P57F_F236v',
              'WOS_P455F_F236h',
              'WOS_P455F_F236v',
              'WOS_P55T_F236',
              'WOS_P455A_F236',
              'WOS_P57P_F242h',
              'WOS_P57P_F242v',
              'WOS_P455P_F242h',
              'WOS_P455P_F242v',
              'WOS_P57F_F242h',
              'WOS_P57F_F242v',
              'WOS_P455F_F242h',
              'WOS_P455F_F242v',
              'WOS_P55T_F242',
              'WOS_P455A_F242',
              'WOS_P57P_F246h',
              'WOS_P57P_F246v',
              'WOS_P455P_F246h',
              'WOS_P455P_F246v',
              'WOS_P57F_F246h',
              'WOS_P57F_F246v',
              'WOS_P455F_F246h',
              'WOS_P455F_F246v',
              'WOS_P55T_F246',
              'WOS_P455A_F246',
              'P57P_264h',
              'P57P_264v',
              'P455P_264h',
              'P455P_264v',
              'P57F_264h',
              'P57F_264v',
              'P455F_264h',
              'P455F_264v',
              'P55T_264',
              'P455A_264',
              'P57P_268h',
              'P57P_268v',
              'P455P_268h',
              'P455P_268v',
              'P57F_268h',
              'P57F_268v',
              'P455F_268h',
              'P455F_268v',
              'P55T_268',
              'P455A_268',
              'P57P_270h',
              'P57P_270v',
              'P455P_270h',
              'P455P_270v',
              'P57F_270h',
              'P57F_270v',
              'P455F_270h',
              'P455F_270v',
              'P55T_270',
              'P455A_270',
              'P57P_FL001Ph',
              'P57P_FL002Ph',
              'P57P_FL012Pv',
              'P57P_FL013Pv',
              'WOS_PCE57P_F274h',
              'WOS_PCE57P_F274v',
              'PCE57P_340v',
              'PCE57P_340h',
              'WOS_PCE55P_F208',
              'WOS_PCE48P_F206h',
              'WOS_PCE48P_F206v',
              'PCE48P_342h',
              'PCE48P_342v',
              'WOS_PCE57P_F300v',
              'WOS_PCE57P_F302v',
              'WOS_PCE57P_F304v',
              'WOS_PCE57P_F312v',
              'WOS_PCE57P_F316v',
              'WOS_PCE57P_F318v',
              'WOS_PCE57P_F324v',
              'PCE57P_330v',
              'Y10BA603h-57',
              'Y10BA603v-57',
              'Y10BA800h-57',
              'Y10BA800v-57',
              'Y13BA455h-57',
              'Y13BA455v-57',
              'Y13BA1295h-57',
              'Y13BA1295v-57',
              'Y17BR001h-57',
              'Y17BR001v-57',
              'Y17BR009h-57',
              'Y17BR009v-57',
              'Y3BB01h-48',
              'Y3BB01v-48',
              'Y4BB22h-48',
              'Y4BB22v-48',
              'Y17BR003h-48',
              'Y17BR003v-48',
              'Y17BR005h-48',
              'Y17BR005v-48',
              'WOS_P57P_',
              'WOS_P57P_572ah',
              'WOS_P57P_574dh',
              'WOS_P57P_576bh',
              'WOS_P57P_578bh',
              'WOS_P57P_582dh',
              'WOS_P57P_586h',
              'WOS_P57P_588ah',
              'WOS_P57P_590av',
              'WOS_P57P_592av',
              'WOS_P57P_594av',
              'WOS_P57P_596av',
              'WOS_P57P_598dh',
              'WOS_P57P_600h',
              'WOS_P57P_604ah',
              'WOS_P57P_610av',
              'WOS_P57P_612av',
              'WOS_P57P_614av',
              'WOS_P57P_616av',
              'WOS_P57F_572ahh',
              'WOS_P57F_572-2ahh',
              'WOS_P57F_574dhh',
              'WOS_P57F_574-2dhh',
              'WOS_P57F_576bhh',
              'WOS_P57F_576-2bhh',
              'WOS_P57F_578bhh',
              'WOS_P57F_578-2bhh',
              'WOS_P57F_582dhh',
              'WOS_P57F_582-2dhh',
              'WOS_P57F_586hh',
              'WOS_P57F_586-2hh',
              'WOS_P57F_588ahh',
              'WOS_P57F_588-2ahh',
              'WOS_P57F_590av',
              'WOS_P57F_590-2av',
              'WOS_P57F_592av',
              'WOS_P57F_592-2av',
              'WOS_P57F_594av',
              'WOS_P57F_594-2av',
              'WOS_P57F_596av',
              'WOS_P57F_596-2av',
              'WOS_P57F_598dhh',
              'WOS_P57F_598-2dhh',
              'WOS_P57F_600hh',
              'WOS_P57F_600-2hh',
              'WOS_P57F_604ahh',
              'WOS_P57F_604-2ahh',
              'WOS_P57F_608hh',
              'WOS_P57F_608-2hh',
              'WOS_P57F_610av',
              'WOS_P57F_610-2av',
              'WOS_P57F_612av',
              'WOS_P57F_612-2av',
              'WOS_P57F_614av',
              'WOS_P57F_614-2av',
              'WOS_P57F_616av',
              'WOS_P57F_616-2av',
            ],
          },
          {
            name: 'Sending Wishes',
            description: 'Send your very best wishes',
            products: [
              'P57P_FL008Ph',
              'WOS_P57P_F154h',
              'WOS_P57P_F154v',
              'WOS_P455P_F154h',
              'WOS_P455P_F154v',
              'WOS_P57F_F154h',
              'WOS_P57F_F154v',
              'WOS_P455F_F154h',
              'WOS_P455F_F154v',
              'WOS_P55T_F154',
              'WOS_P455A_F154',
              'WOS_PCE57P_F308v',
              'Y10BA839h-48',
              'Y10BA839v-48',
              'Y13BA1424h-48',
              'Y13BA1424v-48',
              'WOS_P57P_580bh',
              'WOS_P57P_608h',
              'WOS_P57P_610bv',
              'WOS_P57F_580bhh',
              'WOS_P57F_580-2bhh',
              'WOS_P57F_590cv',
              'WOS_P57F_590-2cv',
              'WOS_P57F_608hh',
              'WOS_P57F_608-2hh',
              'WOS_P57F_610bv',
              'WOS_P57F_610-2bv',
            ],
          },
          {
            name: 'Religious',
            description: 'Share your faith with holiday cards.',
            products: [
              'P57P_274h',
              'P57P_274v',
              'P455P_274h',
              'P455P_274v',
              'P57F_274h',
              'P57F_274v',
              'P455F_274h',
              'P455F_274v',
              'P55T_274',
              'P455A_274',
              'P57P_FL009Ph',
              'WOS_P57P_572dh',
              'WOS_P57P_574ch',
              'WOS_P57P_580ah',
              'WOS_P57P_580dh',
              'WOS_P57P_582bh',
              'WOS_P57P_588dh',
              'WOS_P57P_590dv',
              'WOS_P57P_592cv',
              'WOS_P57P_596bv',
              'WOS_P57P_598bh',
              'WOS_P57P_604bh',
              'WOS_P57P_604ch',
              'WOS_P57P_612bv',
              'WOS_P57P_612ev',
              'WOS_P57P_614bv',
              'WOS_P57P_614ev',
              'WOS_P57P_616cv',
              'WOS_P57P_616ev',
              'WOS_P57F_572dhh',
              'WOS_P57F_572-2dhh',
              'WOS_P57F_574chh',
              'WOS_P57F_574-2chh',
              'WOS_P57F_580ahh',
              'WOS_P57F_580-2ahh',
              'WOS_P57F_580dhh',
              'WOS_P57F_580-2dhh',
              'WOS_P57F_582bhh',
              'WOS_P57F_582-2bhh',
              'WOS_P57F_588dhh',
              'WOS_P57F_588-2dhh',
              'WOS_P57F_590dv',
              'WOS_P57F_590-2dv',
              'WOS_P57F_592cv',
              'WOS_P57F_592-2cv',
              'WOS_P57F_596bv',
              'WOS_P57F_596-2bv',
              'WOS_P57F_598bhh',
              'WOS_P57F_598-2bhh',
              'WOS_P57F_604bhh',
              'WOS_P57F_604-2bhh',
              'WOS_P57F_604chh',
              'WOS_P57F_604-2chh',
              'WOS_P57F_612bv',
              'WOS_P57F_612-2bv',
              'WOS_P57F_612ev',
              'WOS_P57F_612-2ev',
              'WOS_P57F_614bv',
              'WOS_P57F_614-2bv',
              'WOS_P57F_614ev',
              'WOS_P57F_614-2ev',
              'WOS_P57F_616cv',
              'WOS_P57F_616-2cv',
              'WOS_P57F_616ev',
              'WOS_P57F_616-2ev',
            ],
          },
          {
            name: 'Peace',
            description: 'Send a message of peace',
            products: [
              'Y12BP164h-48',
              'Y12BP164v-48',
              'Y10BA196h-48',
              'Y10BA196v-48',
              'PCE57P_332v',
              'P455P_266h',
              'P455P_266v',
              'P57F_266h',
              'P57F_266v',
              'P455F_266h',
              'P455F_266v',
              'P55T_266',
              'P455A_266',
              'WOS_P57P_610cv',
              'WOS_P57F_610cv',
              'WOS_P57F_610-2cv',
            ],
          },
          {
            name: 'New Year',
            description: 'Ring in the New Year in the finest style!',
            products: [
              'P57P_FL002Ph',
              'P57P_FL006Ph',
              'P57P_FL008Ph',
              'P57P_FL013Pv',
              'WOS_PCE55P_F208',
              'WOS_PCE57P_F304v',
              'Y10BA800h-57',
              'Y10BA800v-57',
              'Y13BA1325h-48',
              'WOS_P57P_578ch',
              'WOS_P57P_580ch',
              'WOS_P57P_582ch',
              'WOS_P57P_588ch',
              'WOS_P57P_590bv',
              'WOS_P57P_592dv',
              'WOS_P57P_594cv',
              'WOS_P57P_596dv',
              'WOS_P57P_598ch',
              'WOS_P57P_604eh',
              'WOS_P57P_610dv',
              'WOS_P57P_612dv',
              'WOS_P57P_614dv',
              'WOS_P57P_616bv',
              'WOS_P57F_572bhh',
              'WOS_P57F_572-2bhh',
              'WOS_P57F_574bh',
              'WOS_P57F_574-2bhh',
              'WOS_P57F_578chh',
              'WOS_P57F_578-2chh',
              'WOS_P57F_580chh',
              'WOS_P57F_580-2chh',
              'WOS_P57F_582chh',
              'WOS_P57F_582-2chh',
              'WOS_P57F_588chh',
              'WOS_P57F_588-2chh',
              'WOS_P57F_590bv',
              'WOS_P57F_590-2bv',
              'WOS_P57F_592dv',
              'WOS_P57F_592-2dv',
              'WOS_P57F_594cv',
              'WOS_P57F_594-2cv',
              'WOS_P57F_596dv',
              'WOS_P57F_596-2dv',
              'WOS_P57F_598chh',
              'WOS_P57F_598-2chh',
              'WOS_P57F_610dv',
              'WOS_P57F_610-2dv',
              'WOS_P57F_612dv',
              'WOS_P57F_612-2dv',
              'WOS_P57F_614dv',
              'WOS_P57F_614-2dv',
              'WOS_P57F_616bv',
              'WOS_P57F_616-2bv',
            ],
          },
          {
            name: 'Other Holiday',
            description: "It's the best time of the year!",
            products: [
              'WOS_P57P_F202h',
              'WOS_P57P_F202v',
              'WOS_P455P_F202h',
              'WOS_P455P_F202v',
              'WOS_P57F_F202h',
              'WOS_P57F_F202v',
              'WOS_P455F_F202h',
              'WOS_P455F_F202v',
              'WOS_P55T_F202',
              'WOS_P455A_F202',
              'WOS_P57P_F204h',
              'WOS_P57P_F204v',
              'WOS_P455P_F204h',
              'WOS_P455P_F204v',
              'WOS_P57F_F204h',
              'WOS_P57F_F204v',
              'WOS_P455F_F204h',
              'WOS_P455F_F204v',
              'WOS_P55T_F204',
              'WOS_P455A_F204',
              'P57P_FL008Ph',
              'P57P_FL018Pv',
              'P57P_FL019Pv',
              'P57P_FL020Pv',
              'P57P_FL021Pv',
              'WOS_PCE55P_F212',
              'WOS_PCE57P_F220h',
              'Y11BP158h-57',
              'Y11BP158v-57',
              'Y13BA1424h-48',
              'Y13BA1424v-48',
              'Y10BA839h-48',
              'Y10BA839v-48',
              'Y10BP116h-48',
              'Y10BP116v-48',
              'WOS_P57P_582ch',
              'WOS_P57P_602h',
              'WOS_P57F_582chh',
              'WOS_P57F_582-2chh',
              'WOS_P57F_602hh',
              'WOS_P57F_602-2hh',
            ],
          },
          {
            name: 'Thank You',
            description: 'Give thanks!',
            default: true,
            products: ['P57P_FL010Ph', 'P57P_FL022Pv'],
          },
          {
            name: 'Custom Message',
            description: 'Cards for every occassion',
            products: [
              'WOS_P57P_F228h',
              'WOS_P57P_F228v',
              'WOS_P455P_F228h',
              'WOS_P455P_F228v',
              'WOS_P57F_F228h',
              'WOS_P57F_F228v',
              'WOS_P455F_F228h',
              'WOS_P455F_F228v',
              'WOS_P55T_F228',
              'WOS_P455A_F228',
              'WOS_P57P_F212h',
              'WOS_P57P_F212v',
              'WOS_P455P_F212h',
              'WOS_P455P_F212v',
              'WOS_P57F_F212h',
              'WOS_P57F_F212v',
              'WOS_P455F_F212h',
              'WOS_P455F_F212v',
              'WOS_P55T_F212',
              'WOS_P455A_F212',
              'WOS_PCE55P_F212',
              'P57P_FL008Ph',
              'P57P_FL009Ph',
              'P57P_FL011Ph',
              'P57P_FL023Pv',
              'P57P_FL024Pv',
              'WOS_PCE57P_F216h',
              'WOS_PCE57P_F216v',
              'PCE1218_55P',
              'WOS_PCE55P_F125',
              'WOS_PCE48P_F180h',
              'WOS_PCE48P_F180v',
              'WOS_PCE48P_F185h',
              'WOS_PCE48P_F185v',
              'WOS_PCE48P_FGAL226h',
              'PCE1218_57F_H',
              'PCE1218_57F_V',
              'WOS_PCE57F_F262h',
              'WOS_PCE57F_F262v',
              'WOS_PCE57F_F270h',
              'WOS_PCE57F_F270v',
              'Y9BP100h-57',
              'Y9BP100v-57',
              'YSLOPBh-57',
              'YSLOPBv-57',
              'Y7BP111h-48',
              'Y7BP111v-48',
              'Y7BP118h-48',
              'Y7BP118v-48',
              'Y7BP124h-48',
              'Y7BP124v-48',
              'Y7BP125h-48',
              'Y7BP125v-48',
              'Y8BP102h-48',
              'Y8BP102v-48',
              'Y8BP112h-48',
              'Y8BP112v-48',
              'WOS_P57P_570h',
              'WOS_P57P_584h',
              'WOS_P57F_570h',
              'WOS_P57F_570-2hh',
              'WOS_P57F_584hh',
              'WOS_P57F_584-2hh',
            ],
          },
          {
            name: 'Your Own Design',
            description: 'Blank card products for adding your own design.',
            default: true,
            products: [
              'P1218_57Ph',
              'P1218_57P',
              'P1218_57F_H',
              'P1218_57F_V',
              'P1218_55TF',
              'P1218_455Ph',
              'P1218_455Pv',
              'P1218_455A4v',
              'P1218_455F_H',
              'P1218_455F_V',
            ],
          },
        ],
      },
      {
        groupname: 'size',
        groupLabel: 'Size',
        groupfilters: [
          {
            name: '5x7',
            description: 'See only 5x7 cards',
            products: [
              'WOS_P57P_540h',
              'WOS_P57P_540v',
              'WOS_P57P_542h',
              'WOS_P57P_542v',
              'WOS_P57P_544h',
              'WOS_P57P_544v',
              'WOS_P57P_546h',
              'WOS_P57P_546v',
              'WOS_P57P_548h',
              'WOS_P57P_548v',
              'WOS_P57P_550h',
              'WOS_P57P_550v',
              'WOS_P57P_552h',
              'WOS_P57P_552v',
              'WOS_P57P_554h',
              'WOS_P57P_554v',
              'WOS_P57P_556h',
              'WOS_P57P_556v',
              'WOS_P57P_560h',
              'WOS_P57P_560v',
              'WOS_P57P_562h',
              'WOS_P57P_562v',
              'WOS_P57P_564h',
              'WOS_P57P_564v',
              'WOS_P57P_566h',
              'WOS_P57P_566v',
              'WOS_P57P_568h_22',
              'WOS_P57P_568v_22',
              'WOS_P57F_540h',
              'WOS_P57F_540v',
              'WOS_P57F_542h',
              'WOS_P57F_542v',
              'WOS_P57F_544h',
              'WOS_P57F_544v',
              'WOS_P57F_546h',
              'WOS_P57F_546v',
              'WOS_P57F_548h',
              'WOS_P57F_548v',
              'WOS_P57F_550h',
              'WOS_P57F_550v',
              'WOS_P57F_552h',
              'WOS_P57F_552v',
              'WOS_P57F_554h',
              'WOS_P57F_554v',
              'WOS_P57F_556h',
              'WOS_P57F_556v',
              'WOS_P57F_560h',
              'WOS_P57F_560v',
              'WOS_P57F_562h',
              'WOS_P57F_562v',
              'WOS_P57F_564h',
              'WOS_P57F_564v',
              'WOS_P57F_566h',
              'WOS_P57F_566v',
              'WOS_P57F_568h',
              'WOS_P57F_568v',
              'P1218_57Ph',
              'P1218_57P',
              'WOS_P57P_F154h',
              'WOS_P57P_F154v',
              'WOS_P57P_F178h',
              'WOS_P57P_F178v',
              'WOS_P57P_F186h',
              'WOS_P57P_F186v',
              'WOS_P57P_F190h',
              'WOS_P57P_F190v',
              'WOS_P57P_F192h',
              'WOS_P57P_F192v',
              'WOS_P57P_F202h',
              'WOS_P57P_F202v',
              'WOS_P57P_F204h',
              'WOS_P57P_F204v',
              'WOS_P57P_F212h',
              'WOS_P57P_F212v',
              'WOS_P57P_F228h',
              'WOS_P57P_F228v',
              'WOS_P57P_F236h',
              'WOS_P57P_F236v',
              'WOS_P57P_F238h',
              'WOS_P57P_F238v',
              'WOS_P57P_F242h',
              'WOS_P57P_F242v',
              'WOS_P57P_F246h',
              'WOS_P57P_F246v',
              'P57P_250h',
              'P57P_250v',
              'P57P_252h',
              'P57P_252v',
              'P57P_254h',
              'P57P_254v',
              'P57P_256h',
              'P57P_256v',
              'P57P_258h',
              'P57P_258v',
              'P57P_260h',
              'P57P_260v',
              'P57P_262h',
              'P57P_262v',
              'P57P_264h',
              'P57P_264v',
              'P57P_266h',
              'P57P_266v',
              'P57P_268h',
              'P57P_268v',
              'P57P_270h',
              'P57P_270v',
              'P57P_272h',
              'P57P_272v',
              'P57P_274h',
              'P57P_274v',
              'P1218_57F_H',
              'P1218_57F_V',
              'WOS_P57F_F154h',
              'WOS_P57F_F154v',
              'WOS_P57F_F178h',
              'WOS_P57F_F178v',
              'WOS_P57F_F186h',
              'WOS_P57F_F186v',
              'WOS_P57F_F190h',
              'WOS_P57F_F190v',
              'WOS_P57F_F192h',
              'WOS_P57F_F192v',
              'WOS_P57F_F202h',
              'WOS_P57F_F202v',
              'WOS_P57F_F204h',
              'WOS_P57F_F204v',
              'WOS_P57F_F212h',
              'WOS_P57F_F212v',
              'WOS_P57F_F228h',
              'WOS_P57F_F228v',
              'WOS_P57F_F236h',
              'WOS_P57F_F236v',
              'WOS_P57F_F238h',
              'WOS_P57F_F238v',
              'WOS_P57F_F242h',
              'WOS_P57F_F242v',
              'WOS_P57F_F246h',
              'WOS_P57F_F246v',
              'P57F_250h',
              'P57F_250v',
              'P57F_252h',
              'P57F_252v',
              'P57F_254h',
              'P57F_254v',
              'P57F_256h',
              'P57F_256v',
              'P57F_258h',
              'P57F_258v',
              'P57F_260h',
              'P57F_260v',
              'P57F_262h',
              'P57F_262v',
              'P57F_264h',
              'P57F_264v',
              'P57F_266h',
              'P57F_266v',
              'P57F_268h',
              'P57F_268v',
              'P57F_270h',
              'P57F_270v',
              'P57F_272h',
              'P57F_272v',
              'P57F_274h',
              'P57F_274v',
              'P57P_FL001Ph',
              'P57P_FL002Ph',
              'P57P_FL003Ph',
              'P57P_FL004Ph',
              'P57P_FL005Ph',
              'P57P_FL006Ph',
              'P57P_FL007Ph',
              'P57P_FL009Ph',
              'P57P_FL010Ph',
              'P57P_FL011Ph',
              'P57P_FL012Pv',
              'P57P_FL013Pv',
              'P57P_FL014Pv',
              'P57P_FL015Pv',
              'P57P_FL016Pv',
              'P57P_FL017Pv',
              'P57P_FL018Pv',
              'P57P_FL019Pv',
              'P57P_FL020Pv',
              'P57P_FL021Pv',
              'P57P_FL022Pv',
              'P57P_FL023Pv',
              'P57P_FL024Pv',
              'PCE1218_57Ph',
              'PCE1218_57P',
              'WOS_PCE57P_F120h',
              'WOS_PCE57P_F120v',
              'WOS_PCE57P_F216h',
              'WOS_PCE57P_F216v',
              'WOS_PCE57P_F220h',
              'WOS_PCE57P_F220v',
              'WOS_PCE57P_F224h',
              'WOS_PCE57P_F224v',
              'WOS_PCE57P_F274h',
              'WOS_PCE57P_F274v',
              'PCE57P_340v',
              'PCE57P_340h',
              'PCE1218_57F_H',
              'PCE1218_57F_V',
              'PCE57F_334h',
              'PCE57F_334v',
              'WOS_PCE57F_F262h',
              'WOS_PCE57F_F262v',
              'WOS_PCE57F_F270h',
              'WOS_PCE57F_F270v',
              'PCE1218_57Ph_PopOut-Round',
              'WOS_PCE57P_F302v',
              'WOS_PCE57P_F312v',
              'WOS_PCE57P_F316v',
              'PCE1218_57Ph_PopOut-Scalloped',
              'WOS_PCE57P_F300v',
              'WOS_PCE57P_F304v',
              'WOS_PCE57P_F308v',
              'WOS_PCE57P_F324v',
              'PCE57P_332v',
              'PCE1218_57Ph_PopOut-Tapered',
              'WOS_PCE57P_F310v',
              'WOS_PCE57P_F314v',
              'WOS_PCE57P_F318v',
              'PCE57P_330v',
              'GCARD57',
              'Y6CD01h',
              'Y6CD01v',
              'Y9BP100h-57',
              'Y9BP100v-57',
              'Y10BA603h-57',
              'Y10BA603v-57',
              'Y10BA800h-57',
              'Y10BA800v-57',
              'Y10BP102h-57',
              'Y10BP102v-57',
              'Y10BP108h-57',
              'Y10BP108v-57',
              'Y11BP158h-57',
              'Y11BP158v-57',
              'Y13BA455h-57',
              'Y13BA455v-57',
              'Y13BA487h-57',
              'Y13BA487v-57',
              'Y13BA488h-57',
              'Y13BA488v-57',
              'Y13BA1295h-57',
              'Y13BA1295v-57',
              'Y13BA1391h-57',
              'Y13BA1391v-57',
              'YSLOPBh-57',
              'YSLOPBv-57',
              'Y17BR001h-57',
              'Y17BR001v-57',
              'Y17BR009h-57',
              'Y17BR009v-57',
              'Y17BR011h-57',
              'Y17BR011v-57',
              'WOS_P57P_570h',
              'WOS_P57P_572ah',
              'WOS_P57P_572bh',
              'WOS_P57P_572ch',
              'WOS_P57P_572dh',
              'WOS_P57P_574ah',
              'WOS_P57P_574bh',
              'WOS_P57P_574ch',
              'WOS_P57P_574dh',
              'WOS_P57P_576ah',
              'WOS_P57P_576bh',
              'WOS_P57P_576ch',
              'WOS_P57P_578ah',
              'WOS_P57P_578bh',
              'WOS_P57P_578ch',
              'WOS_P57P_580ah',
              'WOS_P57P_580bh',
              'WOS_P57P_580ch',
              'WOS_P57P_580dh',
              'WOS_P57P_580eh',
              'WOS_P57P_582ah',
              'WOS_P57P_582bh',
              'WOS_P57P_582ch',
              'WOS_P57P_582dh',
              'WOS_P57P_584h',
              'WOS_P57P_586h',
              'WOS_P57P_588ah',
              'WOS_P57P_588bh',
              'WOS_P57P_588ch',
              'WOS_P57P_588dh',
              'WOS_P57P_598ah',
              'WOS_P57P_598bh',
              'WOS_P57P_598ch',
              'WOS_P57P_598dh',
              'WOS_P57P_600h',
              'WOS_P57P_602h',
              'WOS_P57P_604ah',
              'WOS_P57P_604bh',
              'WOS_P57P_604ch',
              'WOS_P57P_604dh',
              'WOS_P57P_604eh',
              'WOS_P57P_606h',
              'WOS_P57P_608h',
              'WOS_P57P_590av',
              'WOS_P57P_590bv',
              'WOS_P57P_590cv',
              'WOS_P57P_590dv',
              'WOS_P57P_592av',
              'WOS_P57P_592bv',
              'WOS_P57P_592cv',
              'WOS_P57P_592dv',
              'WOS_P57P_594av',
              'WOS_P57P_594bv',
              'WOS_P57P_594cv',
              'WOS_P57P_596av',
              'WOS_P57P_596bv',
              'WOS_P57P_596cv',
              'WOS_P57P_596dv',
              'WOS_P57P_610av',
              'WOS_P57P_610bv',
              'WOS_P57P_610cv',
              'WOS_P57P_610dv',
              'WOS_P57P_612av',
              'WOS_P57P_612bv',
              'WOS_P57P_612cv',
              'WOS_P57P_612dv',
              'WOS_P57P_612ev',
              'WOS_P57P_614av',
              'WOS_P57P_614bv',
              'WOS_P57P_614cv',
              'WOS_P57P_614dv',
              'WOS_P57P_614ev',
              'WOS_P57P_616av',
              'WOS_P57P_616bv',
              'WOS_P57P_616cv',
              'WOS_P57P_616dv',
              'WOS_P57P_616ev',
              'WOS_P57F_570h',
              'WOS_P57F_570-2hh',
              'WOS_P57F_572ahh',
              'WOS_P57F_572bhh',
              'WOS_P57F_572chh',
              'WOS_P57F_572dhh',
              'WOS_P57F_572-2ahh',
              'WOS_P57F_572-2bhh',
              'WOS_P57F_572-2chh',
              'WOS_P57F_572-2dhh',
              'WOS_P57F_574ahh',
              'WOS_P57F_574bh',
              'WOS_P57F_574chh',
              'WOS_P57F_574dhh',
              'WOS_P57F_574-2ahh',
              'WOS_P57F_574-2bhh',
              'WOS_P57F_574-2chh',
              'WOS_P57F_574-2dhh',
              'WOS_P57F_576ahh',
              'WOS_P57F_576bhh',
              'WOS_P57F_576chh',
              'WOS_P57F_576-2ahh',
              'WOS_P57F_576-2bhh',
              'WOS_P57F_576-2chh',
              'WOS_P57F_578ahh',
              'WOS_P57F_578bhh',
              'WOS_P57F_578chh',
              'WOS_P57F_578-2ahh',
              'WOS_P57F_578-2bhh',
              'WOS_P57F_578-2chh',
              'WOS_P57F_580ahh',
              'WOS_P57F_580bhh',
              'WOS_P57F_580chh',
              'WOS_P57F_580dhh',
              'WOS_P57F_580ehh',
              'WOS_P57F_580-2ahh',
              'WOS_P57F_580-2bhh',
              'WOS_P57F_580-2chh',
              'WOS_P57F_580-2dhh',
              'WOS_P57F_580-2ehh',
              'WOS_P57F_582ahh',
              'WOS_P57F_582bhh',
              'WOS_P57F_582chh',
              'WOS_P57F_582dhh',
              'WOS_P57F_582-2ahh',
              'WOS_P57F_582-2bhh',
              'WOS_P57F_582-2chh',
              'WOS_P57F_582-2dhh',
              'WOS_P57F_584hh',
              'WOS_P57F_584-2hh',
              'WOS_P57F_586hh',
              'WOS_P57F_586-2hh',
              'WOS_P57F_588ahh',
              'WOS_P57F_588bhh',
              'WOS_P57F_588chh',
              'WOS_P57F_588dhh',
              'WOS_P57F_588-2ahh',
              'WOS_P57F_588-2bhh',
              'WOS_P57F_588-2chh',
              'WOS_P57F_588-2dhh',
              'WOS_P57F_590av',
              'WOS_P57F_590bv',
              'WOS_P57F_590cv',
              'WOS_P57F_590dv',
              'WOS_P57F_590-2av',
              'WOS_P57F_590-2bv',
              'WOS_P57F_590-2cv',
              'WOS_P57F_590-2dv',
              'WOS_P57F_592av',
              'WOS_P57F_592bv',
              'WOS_P57F_592cv',
              'WOS_P57F_592dv',
              'WOS_P57F_592-2av',
              'WOS_P57F_592-2bv',
              'WOS_P57F_592-2cv',
              'WOS_P57F_592-2dv',
              'WOS_P57F_594av',
              'WOS_P57F_594bv',
              'WOS_P57F_594cv',
              'WOS_P57F_594-2av',
              'WOS_P57F_594-2bv',
              'WOS_P57F_594-2cv',
              'WOS_P57F_596av',
              'WOS_P57F_596bv',
              'WOS_P57F_596cv',
              'WOS_P57F_596dv',
              'WOS_P57F_596-2av',
              'WOS_P57F_596-2bv',
              'WOS_P57F_596-2cv',
              'WOS_P57F_596-2dv',
              'WOS_P57F_598ahh',
              'WOS_P57F_598bhh',
              'WOS_P57F_598chh',
              'WOS_P57F_598dhh',
              'WOS_P57F_598-2ahh',
              'WOS_P57F_598-2bhh',
              'WOS_P57F_598-2chh',
              'WOS_P57F_598-2dhh',
              'WOS_P57F_600hh',
              'WOS_P57F_600-2hh',
              'WOS_P57F_602hh',
              'WOS_P57F_602-2hh',
              'WOS_P57F_604ahh',
              'WOS_P57F_604bhh',
              'WOS_P57F_604chh',
              'WOS_P57F_604dhh',
              'WOS_P57F_604-2ahh',
              'WOS_P57F_604-2bhh',
              'WOS_P57F_604-2chh',
              'WOS_P57F_604-2dhh',
              'WOS_P57F_606hh',
              'WOS_P57F_606-2hh',
              'WOS_P57F_608hh',
              'WOS_P57F_608-2hh',
              'WOS_P57F_610av',
              'WOS_P57F_610bv',
              'WOS_P57F_610cv',
              'WOS_P57F_610dv',
              'WOS_P57F_610-2av',
              'WOS_P57F_610-2bv',
              'WOS_P57F_610-2cv',
              'WOS_P57F_610-2dv',
              'WOS_P57F_612av',
              'WOS_P57F_612bv',
              'WOS_P57F_612cv',
              'WOS_P57F_612dv',
              'WOS_P57F_612ev',
              'WOS_P57F_612-2av',
              'WOS_P57F_612-2bv',
              'WOS_P57F_612-2cv',
              'WOS_P57F_612-2dv',
              'WOS_P57F_612-2ev',
              'WOS_P57F_614av',
              'WOS_P57F_614bv',
              'WOS_P57F_614cv',
              'WOS_P57F_614dv',
              'WOS_P57F_614ev',
              'WOS_P57F_614-2av',
              'WOS_P57F_614-2bv',
              'WOS_P57F_614-2cv',
              'WOS_P57F_614-2dv',
              'WOS_P57F_614-2ev',
              'WOS_P57F_616av',
              'WOS_P57F_616bv',
              'WOS_P57F_616cv',
              'WOS_P57F_616dv',
              'WOS_P57F_616ev',
              'WOS_P57F_616-2av',
              'WOS_P57F_616-2bv',
              'WOS_P57F_616-2cv',
              'WOS_P57F_616-2dv',
              'WOS_P57F_616-2ev',
            ],
          },
          {
            name: '5x5',
            description: 'See only 5x5 cards',
            products: [
              'P1218_55TF',
              'WOS_P55T_F154',
              'WOS_P55T_F178',
              'WOS_P55T_F186',
              'WOS_P55T_F190',
              'WOS_P55T_F192',
              'WOS_P55T_F202',
              'WOS_P55T_F204',
              'WOS_P55T_F212',
              'WOS_P55T_F228',
              'WOS_P55T_F236',
              'WOS_P55T_F238',
              'WOS_P55T_F242',
              'WOS_P55T_F246',
              'P55T_250',
              'P55T_252',
              'P55T_254',
              'P55T_256',
              'P55T_258',
              'P55T_260',
              'P55T_262',
              'P55T_264',
              'P55T_266',
              'P55T_268',
              'P55T_270',
              'P55T_272',
              'P55T_274',
              'PCE1218_55P',
              'WOS_PCE55P_F125',
              'WOS_PCE55P_F208',
              'WOS_PCE55P_F212',
              'WOS_PCE55P_F214',
            ],
          },
          {
            name: '4x5.5',
            description: 'See only 4x5.5 cards',
            products: [
              'P1218_455Ph',
              'P1218_455Pv',
              'WOS_P455P_F154h',
              'WOS_P455P_F154v',
              'WOS_P455P_F178h',
              'WOS_P455P_F178v',
              'WOS_P455P_F186h',
              'WOS_P455P_F186v',
              'WOS_P455P_F190h',
              'WOS_P455P_F190v',
              'WOS_P455P_F192h',
              'WOS_P455P_F192v',
              'WOS_P455P_F202h',
              'WOS_P455P_F202v',
              'WOS_P455P_F204h',
              'WOS_P455P_F204v',
              'WOS_P455P_F212h',
              'WOS_P455P_F212v',
              'WOS_P455P_F228h',
              'WOS_P455P_F228v',
              'WOS_P455P_F236h',
              'WOS_P455P_F236v',
              'WOS_P455P_F238h',
              'WOS_P455P_F238v',
              'WOS_P455P_F242h',
              'WOS_P455P_F242v',
              'WOS_P455P_F246h',
              'WOS_P455P_F246v',
              'P455P_250h',
              'P455P_250v',
              'P455P_252h',
              'P455P_252v',
              'P455P_254h',
              'P455P_254v',
              'P455P_256h',
              'P455P_256v',
              'P455P_258h',
              'P455P_258v',
              'P455P_260h',
              'P455P_260v',
              'P455P_262h',
              'P455P_262v',
              'P455P_264h',
              'P455P_264v',
              'P455P_266h',
              'P455P_266v',
              'P455P_268h',
              'P455P_268v',
              'P455P_270h',
              'P455P_270v',
              'P455P_272h',
              'P455P_272v',
              'P455P_274h',
              'P455P_274v',
              'P1218_455A4v',
              'WOS_P455A_F154',
              'WOS_P455A_F178',
              'WOS_P455A_F186',
              'WOS_P455A_F190',
              'WOS_P455A_F192',
              'WOS_P455A_F202',
              'WOS_P455A_F204',
              'WOS_P455A_F212',
              'WOS_P455A_F228',
              'WOS_P455A_F236',
              'WOS_P455A_F238',
              'WOS_P455A_F242',
              'WOS_P455A_F246',
              'P455A_250',
              'P455A_252',
              'P455A_254',
              'P455A_256',
              'P455A_258',
              'P455A_260',
              'P455A_262',
              'P455A_264',
              'P455A_266',
              'P455A_268',
              'P455A_270',
              'P455A_272',
              'P455A_274',
              'P1218_455F_H',
              'P1218_455F_V',
              'WOS_P455F_F154h',
              'WOS_P455F_F154v',
              'WOS_P455F_F178h',
              'WOS_P455F_F178v',
              'WOS_P455F_F186h',
              'WOS_P455F_F186v',
              'WOS_P455F_F190h',
              'WOS_P455F_F190v',
              'WOS_P455F_F192h',
              'WOS_P455F_F192v',
              'WOS_P455F_F202h',
              'WOS_P455F_F202v',
              'WOS_P455F_F204h',
              'WOS_P455F_F204v',
              'WOS_P455F_F212h',
              'WOS_P455F_F212v',
              'WOS_P455F_F228h',
              'WOS_P455F_F228v',
              'WOS_P455F_F236h',
              'WOS_P455F_F236v',
              'WOS_P455F_F238h',
              'WOS_P455F_F238v',
              'WOS_P455F_F242h',
              'WOS_P455F_F242v',
              'WOS_P455F_F246h',
              'WOS_P455F_F246v',
              'P455F_250h',
              'P455F_250v',
              'P455F_252h',
              'P455F_252v',
              'P455F_254h',
              'P455F_254v',
              'P455F_256h',
              'P455F_256v',
              'P455F_258h',
              'P455F_258v',
              'P455F_260h',
              'P455F_260v',
              'P455F_262h',
              'P455F_262v',
              'P455F_264h',
              'P455F_264v',
              'P455F_266h',
              'P455F_266v',
              'P455F_268h',
              'P455F_268v',
              'P455F_270h',
              'P455F_270v',
              'P455F_272h',
              'P455F_272v',
              'P455F_274h',
              'P455F_274v',
            ],
          },
          {
            name: '4x8',
            description: 'See only 4x8 cards',
            products: [
              'PCE1218_48Ph',
              'PCE1218_48Pv',
              'WOS_PCE48P_F180h',
              'WOS_PCE48P_F180v',
              'WOS_PCE48P_F185h',
              'WOS_PCE48P_F185v',
              'WOS_PCE48P_F200h',
              'WOS_PCE48P_F200v',
              'WOS_PCE48P_F202h',
              'WOS_PCE48P_F202v',
              'WOS_PCE48P_F206h',
              'WOS_PCE48P_F206v',
              'WOS_PCE48P_FGAL226h',
              'PCE48P_342h',
              'PCE48P_342v',
              'GCARD48',
              'Y3BB01h-48',
              'Y3BB01v-48',
              'Y3BB04h-48',
              'Y3BB04v-48',
              'Y4BA103h-48',
              'Y4BA103v-48',
              'Y4BB16h-48',
              'Y4BB16v-48',
              'Y4BB22h-48',
              'Y4BB22v-48',
              'Y5BA003h-48',
              'Y5BA003v-48',
              'Y5BA125h-48',
              'Y5BA125v-48',
              'Y5BB21h-48',
              'Y5BB21v-48',
              'Y7BP111h-48',
              'Y7BP111v-48',
              'Y7BP118h-48',
              'Y7BP118v-48',
              'Y7BP124h-48',
              'Y7BP124v-48',
              'Y7BP125h-48',
              'Y7BP125v-48',
              'Y8BP102h-48',
              'Y8BP102v-48',
              'Y8BP112h-48',
              'Y8BP112v-48',
              'Y10BA196h-48',
              'Y10BA196v-48',
              'Y10BA839h-48',
              'Y10BA839v-48',
              'Y10BP116h-48',
              'Y10BP116v-48',
              'Y12BP164h-48',
              'Y12BP164v-48',
              'Y13BA548h-48',
              'Y13BA548v-48',
              'Y13BA1325h-48',
              'Y13BA1325v-48',
              'Y13BA1424h-48',
              'Y13BA1424v-48',
              'Y13BA1429h-48',
              'Y13BA1429v-48',
              'Y13BA1833h-48',
              'Y13BA1833v-48',
              'Y17BR003h-48',
              'Y17BR003v-48',
              'Y17BR005h-48',
              'Y17BR005v-48',
            ],
          },
        ],
      },
      {
        groupname: 'orientation',
        groupLabel: 'Orientation',
        groupfilters: [
          {
            name: 'Horizontal',
            description: 'See only horizontal cards',
            products: [
              'WOS_P57P_540h',
              'WOS_P57P_542h',
              'WOS_P57P_544h',
              'WOS_P57P_546h',
              'WOS_P57P_548h',
              'WOS_P57P_550h',
              'WOS_P57P_552h',
              'WOS_P57P_554h',
              'WOS_P57P_556h',
              'WOS_P57P_560h',
              'WOS_P57P_562h',
              'WOS_P57P_564h',
              'WOS_P57P_566h',
              'WOS_P57P_568h_22',
              'WOS_P57F_540h',
              'WOS_P57F_542h',
              'WOS_P57F_544h',
              'WOS_P57F_546h',
              'WOS_P57F_548h',
              'WOS_P57F_550h',
              'WOS_P57F_552h',
              'WOS_P57F_554h',
              'WOS_P57F_556h',
              'WOS_P57F_560h',
              'WOS_P57F_562h',
              'WOS_P57F_564h',
              'WOS_P57F_566h',
              'WOS_P57F_568h',
              'P1218_455Ph',
              'WOS_P455P_F154h',
              'WOS_P455P_F178h',
              'WOS_P455P_F186h',
              'WOS_P455P_F190h',
              'WOS_P455P_F192h',
              'WOS_P455P_F202h',
              'WOS_P455P_F204h',
              'WOS_P455P_F212h',
              'WOS_P455P_F228h',
              'WOS_P455P_F236h',
              'WOS_P455P_F238h',
              'WOS_P455P_F242h',
              'WOS_P455P_F246h',
              'P455P_250h',
              'P455P_252h',
              'P455P_254h',
              'P455P_256h',
              'P455P_258h',
              'P455P_260h',
              'P455P_262h',
              'P455P_264h',
              'P455P_266h',
              'P455P_268h',
              'P455P_270h',
              'P455P_272h',
              'P455P_274h',
              'P1218_455F_H',
              'WOS_P455F_F154h',
              'WOS_P455F_F178h',
              'WOS_P455F_F186h',
              'WOS_P455F_F190h',
              'WOS_P455F_F192h',
              'WOS_P455F_F202h',
              'WOS_P455F_F204h',
              'WOS_P455F_F212h',
              'WOS_P455F_F228h',
              'WOS_P455F_F236h',
              'WOS_P455F_F238h',
              'WOS_P455F_F242h',
              'WOS_P455F_F246h',
              'P455F_250h',
              'P455F_252h',
              'P455F_254h',
              'P455F_256h',
              'P455F_258h',
              'P455F_260h',
              'P455F_262h',
              'P455F_264h',
              'P455F_266h',
              'P455F_268h',
              'P455F_270h',
              'P455F_272h',
              'P455F_274h',
              'P1218_57Ph',
              'WOS_P57P_F154h',
              'WOS_P57P_F178h',
              'WOS_P57P_F186h',
              'WOS_P57P_F190h',
              'WOS_P57P_F192h',
              'WOS_P57P_F202h',
              'WOS_P57P_F204h',
              'WOS_P57P_F212h',
              'WOS_P57P_F228h',
              'WOS_P57P_F236h',
              'WOS_P57P_F238h',
              'WOS_P57P_F242h',
              'WOS_P57P_F246h',
              'P57P_250h',
              'P57P_252h',
              'P57P_254h',
              'P57P_256h',
              'P57P_258h',
              'P57P_260h',
              'P57P_262h',
              'P57P_264h',
              'P57P_266h',
              'P57P_268h',
              'P57P_270h',
              'P57P_272h',
              'P57P_274h',
              'P1218_57F_H',
              'WOS_P57F_F154h',
              'WOS_P57F_F178h',
              'WOS_P57F_F186h',
              'WOS_P57F_F190h',
              'WOS_P57F_F192h',
              'WOS_P57F_F202h',
              'WOS_P57F_F204h',
              'WOS_P57F_F212h',
              'WOS_P57F_F228h',
              'WOS_P57F_F236h',
              'WOS_P57F_F238h',
              'WOS_P57F_F242h',
              'WOS_P57F_F246h',
              'P57F_250h',
              'P57F_252h',
              'P57F_254h',
              'P57F_256h',
              'P57F_258h',
              'P57F_260h',
              'P57F_262h',
              'P57F_264h',
              'P57F_266h',
              'P57F_268h',
              'P57F_270h',
              'P57F_272h',
              'P57F_274h',
              'P57P_FL001Ph',
              'P57P_FL002Ph',
              'P57P_FL003Ph',
              'P57P_FL004Ph',
              'P57P_FL005Ph',
              'P57P_FL006Ph',
              'P57P_FL007Ph',
              'P57P_FL008Ph',
              'P57P_FL009Ph',
              'P57P_FL010Ph',
              'P57P_FL011Ph',
              'PCE1218_48Ph',
              'WOS_PCE48P_F180h',
              'WOS_PCE48P_F185h',
              'WOS_PCE48P_F200h',
              'WOS_PCE48P_F202h',
              'WOS_PCE48P_F206h',
              'WOS_PCE48P_FGAL226h',
              'PCE48P_342h',
              'PCE1218_57Ph',
              'WOS_PCE57P_F120h',
              'WOS_PCE57P_F216h',
              'WOS_PCE57P_F220h',
              'WOS_PCE57P_F224h',
              'WOS_PCE57P_F274h',
              'PCE57P_340h',
              'PCE1218_57F_H',
              'PCE57F_334h',
              'WOS_PCE57F_F262h',
              'WOS_PCE57F_F270h',
              'GCARD48',
              'GCARD57',
              'Y3BB01h-48',
              'Y3BB04h-48',
              'Y4BA103h-48',
              'Y4BB16h-48',
              'Y4BB22h-48',
              'Y5BA003h-48',
              'Y5BA125h-48',
              'Y5BB21h-48',
              'Y7BP111h-48',
              'Y7BP118h-48',
              'Y7BP124h-48',
              'Y7BP125h-48',
              'Y8BP102h-48',
              'Y8BP112h-48',
              'Y10BA196h-48',
              'Y10BA839h-48',
              'Y10BP116h-48',
              'Y12BP164h-48',
              'Y13BA548h-48',
              'Y13BA1325h-48',
              'Y13BA1424h-48',
              'Y13BA1429h-48',
              'Y13BA1833h-48',
              'Y17BR003h-48',
              'Y17BR005h-48',
              'Y6CD01h',
              'Y9BP100h-57',
              'Y10BA603h-57',
              'Y10BA800h-57',
              'Y10BP102h-57',
              'Y10BP108h-57',
              'Y11BP158h-57',
              'Y13BA455h-57',
              'Y13BA487h-57',
              'Y13BA488h-57',
              'Y13BA1295h-57',
              'Y13BA1391h-57',
              'YSLOPBh-57',
              'Y17BR001h-57',
              'Y17BR009h-57',
              'Y17BR011h-57',
              'WOS_P57P_570h',
              'WOS_P57P_572ah',
              'WOS_P57P_572bh',
              'WOS_P57P_572ch',
              'WOS_P57P_572dh',
              'WOS_P57P_574ah',
              'WOS_P57P_574bh',
              'WOS_P57P_574ch',
              'WOS_P57P_574dh',
              'WOS_P57P_576ah',
              'WOS_P57P_576bh',
              'WOS_P57P_576ch',
              'WOS_P57P_578ah',
              'WOS_P57P_578bh',
              'WOS_P57P_578ch',
              'WOS_P57P_580ah',
              'WOS_P57P_580bh',
              'WOS_P57P_580ch',
              'WOS_P57P_580dh',
              'WOS_P57P_580eh',
              'WOS_P57P_582ah',
              'WOS_P57P_582bh',
              'WOS_P57P_582ch',
              'WOS_P57P_582dh',
              'WOS_P57P_584h',
              'WOS_P57P_586h',
              'WOS_P57P_588ah',
              'WOS_P57P_588bh',
              'WOS_P57P_588ch',
              'WOS_P57P_588dh',
              'WOS_P57P_598ah',
              'WOS_P57P_598bh',
              'WOS_P57P_598ch',
              'WOS_P57P_598dh',
              'WOS_P57P_600h',
              'WOS_P57P_602h',
              'WOS_P57P_604ah',
              'WOS_P57P_604bh',
              'WOS_P57P_604ch',
              'WOS_P57P_604dh',
              'WOS_P57P_604eh',
              'WOS_P57P_606h',
              'WOS_P57P_608h',
              'WOS_P57F_570h',
              'WOS_P57F_570-2hh',
              'WOS_P57F_572ahh',
              'WOS_P57F_572bhh',
              'WOS_P57F_572chh',
              'WOS_P57F_572dhh',
              'WOS_P57F_572-2ahh',
              'WOS_P57F_572-2bhh',
              'WOS_P57F_572-2chh',
              'WOS_P57F_572-2dhh',
              'WOS_P57F_574ahh',
              'WOS_P57F_574bh',
              'WOS_P57F_574chh',
              'WOS_P57F_574dhh',
              'WOS_P57F_574-2ahh',
              'WOS_P57F_574-2bhh',
              'WOS_P57F_574-2chh',
              'WOS_P57F_574-2dhh',
              'WOS_P57F_576ahh',
              'WOS_P57F_576bhh',
              'WOS_P57F_576chh',
              'WOS_P57F_576-2ahh',
              'WOS_P57F_576-2bhh',
              'WOS_P57F_576-2chh',
              'WOS_P57F_578ahh',
              'WOS_P57F_578bhh',
              'WOS_P57F_578chh',
              'WOS_P57F_578-2ahh',
              'WOS_P57F_578-2bhh',
              'WOS_P57F_578-2chh',
              'WOS_P57F_580ahh',
              'WOS_P57F_580bhh',
              'WOS_P57F_580chh',
              'WOS_P57F_580dhh',
              'WOS_P57F_580ehh',
              'WOS_P57F_580-2ahh',
              'WOS_P57F_580-2bhh',
              'WOS_P57F_580-2chh',
              'WOS_P57F_580-2dhh',
              'WOS_P57F_580-2ehh',
              'WOS_P57F_582ahh',
              'WOS_P57F_582bhh',
              'WOS_P57F_582chh',
              'WOS_P57F_582dhh',
              'WOS_P57F_582-2ahh',
              'WOS_P57F_582-2bhh',
              'WOS_P57F_582-2chh',
              'WOS_P57F_582-2dhh',
              'WOS_P57F_584hh',
              'WOS_P57F_584-2hh',
              'WOS_P57F_586hh',
              'WOS_P57F_586-2hh',
              'WOS_P57F_588ahh',
              'WOS_P57F_588bhh',
              'WOS_P57F_588chh',
              'WOS_P57F_588dhh',
              'WOS_P57F_588-2ahh',
              'WOS_P57F_588-2bhh',
              'WOS_P57F_588-2chh',
              'WOS_P57F_588-2dhh',
              'WOS_P57F_598ahh',
              'WOS_P57F_598bhh',
              'WOS_P57F_598chh',
              'WOS_P57F_598dhh',
              'WOS_P57F_598-2ahh',
              'WOS_P57F_598-2bhh',
              'WOS_P57F_598-2chh',
              'WOS_P57F_598-2dhh',
              'WOS_P57F_600hh',
              'WOS_P57F_600-2hh',
              'WOS_P57F_602hh',
              'WOS_P57F_602-2hh',
              'WOS_P57F_604ahh',
              'WOS_P57F_604bhh',
              'WOS_P57F_604chh',
              'WOS_P57F_604dhh',
              'WOS_P57F_604-2ahh',
              'WOS_P57F_604-2bhh',
              'WOS_P57F_604-2chh',
              'WOS_P57F_604-2dhh',
              'WOS_P57F_606hh',
              'WOS_P57F_606-2hh',
              'WOS_P57F_608hh',
              'WOS_P57F_608-2hh',
            ],
          },
          {
            name: 'Vertical',
            description: 'See only vertical cards',
            products: [
              'WOS_P57P_540v',
              'WOS_P57P_542v',
              'WOS_P57P_544v',
              'WOS_P57P_546v',
              'WOS_P57P_548v',
              'WOS_P57P_550v',
              'WOS_P57P_552v',
              'WOS_P57P_554v',
              'WOS_P57P_556v',
              'WOS_P57P_560v',
              'WOS_P57P_562v',
              'WOS_P57P_564v',
              'WOS_P57P_566v',
              'WOS_P57P_568v_22',
              'WOS_P57F_540v',
              'WOS_P57F_542v',
              'WOS_P57F_544v',
              'WOS_P57F_546v',
              'WOS_P57F_548v',
              'WOS_P57F_550v',
              'WOS_P57F_552v',
              'WOS_P57F_554v',
              'WOS_P57F_556v',
              'WOS_P57F_560v',
              'WOS_P57F_562v',
              'WOS_P57F_564v',
              'WOS_P57F_566v',
              'WOS_P57F_568v',
              'P1218_455Pv',
              'WOS_P455P_F154v',
              'WOS_P455P_F178v',
              'WOS_P455P_F186v',
              'WOS_P455P_F190v',
              'WOS_P455P_F192v',
              'WOS_P455P_F202v',
              'WOS_P455P_F204v',
              'WOS_P455P_F212v',
              'WOS_P455P_F228v',
              'WOS_P455P_F236v',
              'WOS_P455P_F238v',
              'WOS_P455P_F242v',
              'WOS_P455P_F246v',
              'P455P_250v',
              'P455P_252v',
              'P455P_254v',
              'P455P_256v',
              'P455P_258v',
              'P455P_260v',
              'P455P_262v',
              'P455P_264v',
              'P455P_266v',
              'P455P_268v',
              'P455P_270v',
              'P455P_272v',
              'P455P_274v',
              'P1218_455A4v',
              'WOS_P455A_F154',
              'WOS_P455A_F178',
              'WOS_P455A_F186',
              'WOS_P455A_F190',
              'WOS_P455A_F192',
              'WOS_P455A_F202',
              'WOS_P455A_F204',
              'WOS_P455A_F212',
              'WOS_P455A_F228',
              'WOS_P455A_F236',
              'WOS_P455A_F238',
              'WOS_P455A_F242',
              'WOS_P455A_F246',
              'P455A_250',
              'P455A_252',
              'P455A_254',
              'P455A_256',
              'P455A_258',
              'P455A_260',
              'P455A_262',
              'P455A_264',
              'P455A_266',
              'P455A_268',
              'P455A_270',
              'P455A_272',
              'P455A_274',
              'P1218_455F_V',
              'WOS_P455F_F154v',
              'WOS_P455F_F178v',
              'WOS_P455F_F186v',
              'WOS_P455F_F190v',
              'WOS_P455F_F192v',
              'WOS_P455F_F202v',
              'WOS_P455F_F204v',
              'WOS_P455F_F212v',
              'WOS_P455F_F228v',
              'WOS_P455F_F236v',
              'WOS_P455F_F238v',
              'WOS_P455F_F242v',
              'WOS_P455F_F246v',
              'P455F_250v',
              'P455F_252v',
              'P455F_254v',
              'P455F_256v',
              'P455F_258v',
              'P455F_260v',
              'P455F_262v',
              'P455F_264v',
              'P455F_266v',
              'P455F_268v',
              'P455F_270v',
              'P455F_272v',
              'P455F_274v',
              'P1218_57P',
              'WOS_P57P_F154v',
              'WOS_P57P_F178v',
              'WOS_P57P_F186v',
              'WOS_P57P_F190v',
              'WOS_P57P_F192v',
              'WOS_P57P_F202v',
              'WOS_P57P_F204v',
              'WOS_P57P_F212v',
              'WOS_P57P_F228v',
              'WOS_P57P_F236v',
              'WOS_P57P_F238v',
              'WOS_P57P_F242v',
              'WOS_P57P_F246v',
              'P57P_250v',
              'P57P_252v',
              'P57P_254v',
              'P57P_256v',
              'P57P_258v',
              'P57P_260v',
              'P57P_262v',
              'P57P_264v',
              'P57P_266v',
              'P57P_268v',
              'P57P_270v',
              'P57P_272v',
              'P57P_274v',
              'P1218_57F_V',
              'WOS_P57F_F154v',
              'WOS_P57F_F178v',
              'WOS_P57F_F186v',
              'WOS_P57F_F190v',
              'WOS_P57F_F192v',
              'WOS_P57F_F202v',
              'WOS_P57F_F204v',
              'WOS_P57F_F212v',
              'WOS_P57F_F228v',
              'WOS_P57F_F236v',
              'WOS_P57F_F238v',
              'WOS_P57F_F242v',
              'WOS_P57F_F246v',
              'P57F_250v',
              'P57F_252v',
              'P57F_254v',
              'P57F_256v',
              'P57F_258v',
              'P57F_260v',
              'P57F_262v',
              'P57F_264v',
              'P57F_266v',
              'P57F_268v',
              'P57F_270v',
              'P57F_272v',
              'P57F_274v',
              'P57P_FL012Pv',
              'P57P_FL013Pv',
              'P57P_FL014Pv',
              'P57P_FL015Pv',
              'P57P_FL016Pv',
              'P57P_FL017Pv',
              'P57P_FL018Pv',
              'P57P_FL019Pv',
              'P57P_FL020Pv',
              'P57P_FL021Pv',
              'P57P_FL022Pv',
              'P57P_FL023Pv',
              'P57P_FL024Pv',
              'PCE1218_48Pv',
              'WOS_PCE48P_F180v',
              'WOS_PCE48P_F185v',
              'WOS_PCE48P_F200v',
              'WOS_PCE48P_F202v',
              'WOS_PCE48P_F206v',
              'PCE48P_342v',
              'PCE1218_57P',
              'WOS_PCE57P_F120v',
              'WOS_PCE57P_F216v',
              'WOS_PCE57P_F220v',
              'WOS_PCE57P_F224v',
              'WOS_PCE57P_F274v',
              'PCE57P_340v',
              'PCE1218_57F_V',
              'PCE57F_334v',
              'WOS_PCE57F_F262v',
              'WOS_PCE57F_F270v',
              'PCE1218_57Ph_PopOut-Round',
              'WOS_PCE57P_F302v',
              'WOS_PCE57P_F312v',
              'WOS_PCE57P_F316v',
              'PCE1218_57Ph_PopOut-Scalloped',
              'WOS_PCE57P_F300v',
              'WOS_PCE57P_F304v',
              'WOS_PCE57P_F308v',
              'WOS_PCE57P_F324v',
              'PCE57P_332v',
              'PCE1218_57Ph_PopOut-Tapered',
              'WOS_PCE57P_F310v',
              'WOS_PCE57P_F314v',
              'WOS_PCE57P_F318v',
              'PCE57P_330v',
              'Y3BB01v-48',
              'Y3BB04v-48',
              'Y4BA103v-48',
              'Y4BB16v-48',
              'Y4BB22v-48',
              'Y5BA003v-48',
              'Y5BA125v-48',
              'Y5BB21v-48',
              'Y7BP111v-48',
              'Y7BP118v-48',
              'Y7BP124v-48',
              'Y7BP125v-48',
              'Y8BP102v-48',
              'Y8BP112v-48',
              'Y10BA196v-48',
              'Y10BA839v-48',
              'Y10BP116v-48',
              'Y12BP164v-48',
              'Y13BA548v-48',
              'Y13BA1325v-48',
              'Y13BA1424v-48',
              'Y13BA1429v-48',
              'Y13BA1833v-48',
              'Y17BR003v-48',
              'Y17BR005v-48',
              'Y6CD01v',
              'Y9BP100v-57',
              'Y10BA603v-57',
              'Y10BA800v-57',
              'Y10BP102v-57',
              'Y10BP108v-57',
              'Y11BP158v-57',
              'Y13BA455v-57',
              'Y13BA487v-57',
              'Y13BA488v-57',
              'Y13BA1295v-57',
              'Y13BA1391v-57',
              'YSLOPBv-57',
              'Y17BR001v-57',
              'Y17BR009v-57',
              'Y17BR011v-57',
              'WOS_P57P_590av',
              'WOS_P57P_590bv',
              'WOS_P57P_590cv',
              'WOS_P57P_590dv',
              'WOS_P57P_592av',
              'WOS_P57P_592bv',
              'WOS_P57P_592cv',
              'WOS_P57P_592dv',
              'WOS_P57P_594av',
              'WOS_P57P_594bv',
              'WOS_P57P_594cv',
              'WOS_P57P_596av',
              'WOS_P57P_596bv',
              'WOS_P57P_596cv',
              'WOS_P57P_596dv',
              'WOS_P57P_610av',
              'WOS_P57P_610bv',
              'WOS_P57P_610cv',
              'WOS_P57P_610dv',
              'WOS_P57P_612av',
              'WOS_P57P_612bv',
              'WOS_P57P_612cv',
              'WOS_P57P_612dv',
              'WOS_P57P_612ev',
              'WOS_P57P_614av',
              'WOS_P57P_614bv',
              'WOS_P57P_614cv',
              'WOS_P57P_614dv',
              'WOS_P57P_614ev',
              'WOS_P57P_616av',
              'WOS_P57P_616bv',
              'WOS_P57P_616cv',
              'WOS_P57P_616dv',
              'WOS_P57P_616ev',
              'WOS_P57F_590av',
              'WOS_P57F_590bv',
              'WOS_P57F_590cv',
              'WOS_P57F_590dv',
              'WOS_P57F_590-2av',
              'WOS_P57F_590-2bv',
              'WOS_P57F_590-2cv',
              'WOS_P57F_590-2dv',
              'WOS_P57F_592av',
              'WOS_P57F_592bv',
              'WOS_P57F_592cv',
              'WOS_P57F_592dv',
              'WOS_P57F_592-2av',
              'WOS_P57F_592-2bv',
              'WOS_P57F_592-2cv',
              'WOS_P57F_592-2dv',
              'WOS_P57F_594av',
              'WOS_P57F_594bv',
              'WOS_P57F_594cv',
              'WOS_P57F_594-2av',
              'WOS_P57F_594-2bv',
              'WOS_P57F_594-2cv',
              'WOS_P57F_596av',
              'WOS_P57F_596bv',
              'WOS_P57F_596cv',
              'WOS_P57F_596dv',
              'WOS_P57F_596-2av',
              'WOS_P57F_596-2bv',
              'WOS_P57F_596-2cv',
              'WOS_P57F_596-2dv',
              'WOS_P57F_610av',
              'WOS_P57F_610bv',
              'WOS_P57F_610cv',
              'WOS_P57F_610dv',
              'WOS_P57F_610-2av',
              'WOS_P57F_610-2bv',
              'WOS_P57F_610-2cv',
              'WOS_P57F_610-2dv',
              'WOS_P57F_612av',
              'WOS_P57F_612bv',
              'WOS_P57F_612cv',
              'WOS_P57F_612dv',
              'WOS_P57F_612ev',
              'WOS_P57F_612-2av',
              'WOS_P57F_612-2bv',
              'WOS_P57F_612-2cv',
              'WOS_P57F_612-2dv',
              'WOS_P57F_612-2ev',
              'WOS_P57F_614av',
              'WOS_P57F_614bv',
              'WOS_P57F_614cv',
              'WOS_P57F_614dv',
              'WOS_P57F_614ev',
              'WOS_P57F_614-2av',
              'WOS_P57F_614-2bv',
              'WOS_P57F_614-2cv',
              'WOS_P57F_614-2dv',
              'WOS_P57F_614-2ev',
              'WOS_P57F_616av',
              'WOS_P57F_616bv',
              'WOS_P57F_616cv',
              'WOS_P57F_616dv',
              'WOS_P57F_616ev',
              'WOS_P57F_616-2av',
              'WOS_P57F_616-2bv',
              'WOS_P57F_616-2cv',
              'WOS_P57F_616-2dv',
              'WOS_P57F_616-2ev',
            ],
          },
          {
            name: 'Square',
            description: 'See only square cards',
            products: [
              'P1218_55TF',
              'WOS_P55T_F154',
              'WOS_P55T_F178',
              'WOS_P55T_F186',
              'WOS_P55T_F190',
              'WOS_P55T_F192',
              'WOS_P55T_F202',
              'WOS_P55T_F204',
              'WOS_P55T_F212',
              'WOS_P55T_F228',
              'WOS_P55T_F236',
              'WOS_P55T_F238',
              'WOS_P55T_F242',
              'WOS_P55T_F246',
              'P55T_250',
              'P55T_252',
              'P55T_254',
              'P55T_256',
              'P55T_258',
              'P55T_260',
              'P55T_262',
              'P55T_264',
              'P55T_266',
              'P55T_268',
              'P55T_270',
              'P55T_272',
              'P55T_274',
              'PCE1218_55P',
              'WOS_PCE55P_F125',
              'WOS_PCE55P_F208',
              'WOS_PCE55P_F212',
              'WOS_PCE55P_F214',
            ],
          },
        ],
      },
      {
        groupname: 'format',
        groupLabel: 'Format',
        groupfilters: [
          {
            name: 'Flat',
            description: 'See only Flat cards',
            products: [
              'WOS_P57P_540h',
              'WOS_P57P_540v',
              'WOS_P57P_542h',
              'WOS_P57P_542v',
              'WOS_P57P_544h',
              'WOS_P57P_544v',
              'WOS_P57P_546h',
              'WOS_P57P_546v',
              'WOS_P57P_548h',
              'WOS_P57P_548v',
              'WOS_P57P_550h',
              'WOS_P57P_550v',
              'WOS_P57P_552h',
              'WOS_P57P_552v',
              'WOS_P57P_554h',
              'WOS_P57P_554v',
              'WOS_P57P_556h',
              'WOS_P57P_556v',
              'WOS_P57P_560h',
              'WOS_P57P_560v',
              'WOS_P57P_562h',
              'WOS_P57P_562v',
              'WOS_P57P_564h',
              'WOS_P57P_564v',
              'WOS_P57P_566h',
              'WOS_P57P_566v',
              'WOS_P57P_568h_22',
              'WOS_P57P_568v_22',
              'P1218_455Ph',
              'P1218_455Pv',
              'WOS_P455P_F154h',
              'WOS_P455P_F154v',
              'WOS_P455P_F178h',
              'WOS_P455P_F178v',
              'WOS_P455P_F186h',
              'WOS_P455P_F186v',
              'WOS_P455P_F190h',
              'WOS_P455P_F190v',
              'WOS_P455P_F192h',
              'WOS_P455P_F192v',
              'WOS_P455P_F202h',
              'WOS_P455P_F202v',
              'WOS_P455P_F204h',
              'WOS_P455P_F204v',
              'WOS_P455P_F212h',
              'WOS_P455P_F212v',
              'WOS_P455P_F228h',
              'WOS_P455P_F228v',
              'WOS_P455P_F236h',
              'WOS_P455P_F236v',
              'WOS_P455P_F238h',
              'WOS_P455P_F238v',
              'WOS_P455P_F242h',
              'WOS_P455P_F242v',
              'WOS_P455P_F246h',
              'WOS_P455P_F246v',
              'P455P_250h',
              'P455P_250v',
              'P455P_252h',
              'P455P_252v',
              'P455P_254h',
              'P455P_254v',
              'P455P_256h',
              'P455P_256v',
              'P455P_258h',
              'P455P_258v',
              'P455P_260h',
              'P455P_260v',
              'P455P_262h',
              'P455P_262v',
              'P455P_264h',
              'P455P_264v',
              'P455P_266h',
              'P455P_266v',
              'P455P_268h',
              'P455P_268v',
              'P455P_270h',
              'P455P_270v',
              'P455P_272h',
              'P455P_272v',
              'P455P_274h',
              'P455P_274v',
              'P1218_57Ph',
              'P1218_57P',
              'WOS_P57P_F154h',
              'WOS_P57P_F154v',
              'WOS_P57P_F178h',
              'WOS_P57P_F178v',
              'WOS_P57P_F186h',
              'WOS_P57P_F186v',
              'WOS_P57P_F190h',
              'WOS_P57P_F190v',
              'WOS_P57P_F192h',
              'WOS_P57P_F192v',
              'WOS_P57P_F202h',
              'WOS_P57P_F202v',
              'WOS_P57P_F204h',
              'WOS_P57P_F204v',
              'WOS_P57P_F212h',
              'WOS_P57P_F212v',
              'WOS_P57P_F228h',
              'WOS_P57P_F228v',
              'WOS_P57P_F236h',
              'WOS_P57P_F236v',
              'WOS_P57P_F238h',
              'WOS_P57P_F238v',
              'WOS_P57P_F242h',
              'WOS_P57P_F242v',
              'WOS_P57P_F246h',
              'WOS_P57P_F246v',
              'P57P_250h',
              'P57P_250v',
              'P57P_252h',
              'P57P_252v',
              'P57P_254h',
              'P57P_254v',
              'P57P_256h',
              'P57P_256v',
              'P57P_258h',
              'P57P_258v',
              'P57P_260h',
              'P57P_260v',
              'P57P_262h',
              'P57P_262v',
              'P57P_264h',
              'P57P_264v',
              'P57P_266h',
              'P57P_266v',
              'P57P_268h',
              'P57P_268v',
              'P57P_270h',
              'P57P_270v',
              'P57P_272h',
              'P57P_272v',
              'P57P_274h',
              'P57P_274v',
              'P57P_FL001Ph',
              'P57P_FL002Ph',
              'P57P_FL003Ph',
              'P57P_FL004Ph',
              'P57P_FL005Ph',
              'P57P_FL006Ph',
              'P57P_FL007Ph',
              'P57P_FL008Ph',
              'P57P_FL009Ph',
              'P57P_FL010Ph',
              'P57P_FL011Ph',
              'P57P_FL012Pv',
              'P57P_FL013Pv',
              'P57P_FL014Pv',
              'P57P_FL015Pv',
              'P57P_FL016Pv',
              'P57P_FL017Pv',
              'P57P_FL018Pv',
              'P57P_FL019Pv',
              'P57P_FL020Pv',
              'P57P_FL021Pv',
              'P57P_FL022Pv',
              'P57P_FL023Pv',
              'P57P_FL024Pv',
              'PCE1218_48Ph',
              'PCE1218_48Pv',
              'WOS_PCE48P_F180h',
              'WOS_PCE48P_F180v',
              'WOS_PCE48P_F185h',
              'WOS_PCE48P_F185v',
              'WOS_PCE48P_F200h',
              'WOS_PCE48P_F200v',
              'WOS_PCE48P_F202h',
              'WOS_PCE48P_F202v',
              'WOS_PCE48P_F206h',
              'WOS_PCE48P_F206v',
              'WOS_PCE48P_FGAL226h',
              'PCE48P_342h',
              'PCE48P_342v',
              'PCE1218_55P',
              'WOS_PCE55P_F125',
              'WOS_PCE55P_F208',
              'WOS_PCE55P_F212',
              'WOS_PCE55P_F214',
              'PCE1218_57Ph',
              'PCE1218_57P',
              'WOS_PCE57P_F120h',
              'WOS_PCE57P_F120v',
              'WOS_PCE57P_F216h',
              'WOS_PCE57P_F216v',
              'WOS_PCE57P_F220h',
              'WOS_PCE57P_F220v',
              'WOS_PCE57P_F224h',
              'WOS_PCE57P_F224v',
              'WOS_PCE57P_F274h',
              'WOS_PCE57P_F274v',
              'PCE57P_340v',
              'PCE57P_340h',
              'WOS_P57P_570h',
              'WOS_P57P_572ah',
              'WOS_P57P_572bh',
              'WOS_P57P_572ch',
              'WOS_P57P_572dh',
              'WOS_P57P_574ah',
              'WOS_P57P_574bh',
              'WOS_P57P_574ch',
              'WOS_P57P_574dh',
              'WOS_P57P_576ah',
              'WOS_P57P_576bh',
              'WOS_P57P_576ch',
              'WOS_P57P_578ah',
              'WOS_P57P_578bh',
              'WOS_P57P_578ch',
              'WOS_P57P_580ah',
              'WOS_P57P_580bh',
              'WOS_P57P_580ch',
              'WOS_P57P_580dh',
              'WOS_P57P_580eh',
              'WOS_P57P_582ah',
              'WOS_P57P_582bh',
              'WOS_P57P_582ch',
              'WOS_P57P_582dh',
              'WOS_P57P_584h',
              'WOS_P57P_586h',
              'WOS_P57P_588ah',
              'WOS_P57P_588bh',
              'WOS_P57P_588ch',
              'WOS_P57P_588dh',
              'WOS_P57P_598ah',
              'WOS_P57P_598bh',
              'WOS_P57P_598ch',
              'WOS_P57P_598dh',
              'WOS_P57P_600h',
              'WOS_P57P_602h',
              'WOS_P57P_604ah',
              'WOS_P57P_604bh',
              'WOS_P57P_604ch',
              'WOS_P57P_604dh',
              'WOS_P57P_604eh',
              'WOS_P57P_606h',
              'WOS_P57P_608h',
              'WOS_P57P_590av',
              'WOS_P57P_590bv',
              'WOS_P57P_590cv',
              'WOS_P57P_590dv',
              'WOS_P57P_592av',
              'WOS_P57P_592bv',
              'WOS_P57P_592cv',
              'WOS_P57P_592dv',
              'WOS_P57P_594av',
              'WOS_P57P_594bv',
              'WOS_P57P_594cv',
              'WOS_P57P_596av',
              'WOS_P57P_596bv',
              'WOS_P57P_596cv',
              'WOS_P57P_596dv',
              'WOS_P57P_610av',
              'WOS_P57P_610bv',
              'WOS_P57P_610cv',
              'WOS_P57P_610dv',
              'WOS_P57P_612av',
              'WOS_P57P_612bv',
              'WOS_P57P_612cv',
              'WOS_P57P_612dv',
              'WOS_P57P_612ev',
              'WOS_P57P_614av',
              'WOS_P57P_614bv',
              'WOS_P57P_614cv',
              'WOS_P57P_614dv',
              'WOS_P57P_614ev',
              'WOS_P57P_616av',
              'WOS_P57P_616bv',
              'WOS_P57P_616cv',
              'WOS_P57P_616dv',
              'WOS_P57P_616ev',
            ],
          },
          {
            name: 'Single Fold',
            description: 'See only single fold cards',
            products: [
              'WOS_P57F_540h',
              'WOS_P57F_540v',
              'WOS_P57F_542h',
              'WOS_P57F_542v',
              'WOS_P57F_544h',
              'WOS_P57F_544v',
              'WOS_P57F_546h',
              'WOS_P57F_546v',
              'WOS_P57F_548h',
              'WOS_P57F_548v',
              'WOS_P57F_550h',
              'WOS_P57F_550v',
              'WOS_P57F_552h',
              'WOS_P57F_552v',
              'WOS_P57F_554h',
              'WOS_P57F_554v',
              'WOS_P57F_556h',
              'WOS_P57F_556v',
              'WOS_P57F_560h',
              'WOS_P57F_560v',
              'WOS_P57F_562h',
              'WOS_P57F_562v',
              'WOS_P57F_564h',
              'WOS_P57F_564v',
              'WOS_P57F_566h',
              'WOS_P57F_566v',
              'WOS_P57F_568h',
              'WOS_P57F_568v',
              'P1218_455F_H',
              'P1218_455F_V',
              'WOS_P455F_F154h',
              'WOS_P455F_F154v',
              'WOS_P455F_F178h',
              'WOS_P455F_F178v',
              'WOS_P455F_F186h',
              'WOS_P455F_F186v',
              'WOS_P455F_F190h',
              'WOS_P455F_F190v',
              'WOS_P455F_F192h',
              'WOS_P455F_F192v',
              'WOS_P455F_F202h',
              'WOS_P455F_F202v',
              'WOS_P455F_F204h',
              'WOS_P455F_F204v',
              'WOS_P455F_F212h',
              'WOS_P455F_F212v',
              'WOS_P455F_F228h',
              'WOS_P455F_F228v',
              'WOS_P455F_F236h',
              'WOS_P455F_F236v',
              'WOS_P455F_F238h',
              'WOS_P455F_F238v',
              'WOS_P455F_F242h',
              'WOS_P455F_F242v',
              'WOS_P455F_F246h',
              'WOS_P455F_F246v',
              'P455F_250h',
              'P455F_250v',
              'P455F_252h',
              'P455F_252v',
              'P455F_254h',
              'P455F_254v',
              'P455F_256h',
              'P455F_256v',
              'P455F_258h',
              'P455F_258v',
              'P455F_260h',
              'P455F_260v',
              'P455F_262h',
              'P455F_262v',
              'P455F_264h',
              'P455F_264v',
              'P455F_266h',
              'P455F_266v',
              'P455F_268h',
              'P455F_268v',
              'P455F_270h',
              'P455F_270v',
              'P455F_272h',
              'P455F_272v',
              'P455F_274h',
              'P455F_274v',
              'P1218_57F_H',
              'P1218_57F_V',
              'WOS_P57F_F154h',
              'WOS_P57F_F154v',
              'WOS_P57F_F178h',
              'WOS_P57F_F178v',
              'WOS_P57F_F186h',
              'WOS_P57F_F186v',
              'WOS_P57F_F190h',
              'WOS_P57F_F190v',
              'WOS_P57F_F192h',
              'WOS_P57F_F192v',
              'WOS_P57F_F202h',
              'WOS_P57F_F202v',
              'WOS_P57F_F204h',
              'WOS_P57F_F204v',
              'WOS_P57F_F212h',
              'WOS_P57F_F212v',
              'WOS_P57F_F228h',
              'WOS_P57F_F228v',
              'WOS_P57F_F236h',
              'WOS_P57F_F236v',
              'WOS_P57F_F238h',
              'WOS_P57F_F238v',
              'WOS_P57F_F242h',
              'WOS_P57F_F242v',
              'WOS_P57F_F246h',
              'WOS_P57F_F246v',
              'P57F_250h',
              'P57F_250v',
              'P57F_252h',
              'P57F_252v',
              'P57F_254h',
              'P57F_254v',
              'P57F_256h',
              'P57F_256v',
              'P57F_258h',
              'P57F_258v',
              'P57F_260h',
              'P57F_260v',
              'P57F_262h',
              'P57F_262v',
              'P57F_264h',
              'P57F_264v',
              'P57F_266h',
              'P57F_266v',
              'P57F_268h',
              'P57F_268v',
              'P57F_270h',
              'P57F_270v',
              'P57F_272h',
              'P57F_272v',
              'P57F_274h',
              'P57F_274v',
              'PCE1218_57F_H',
              'PCE1218_57F_V',
              'PCE57F_334h',
              'PCE57F_334v',
              'WOS_PCE57F_F262h',
              'WOS_PCE57F_F262v',
              'WOS_PCE57F_F270h',
              'WOS_PCE57F_F270v',
              'WOS_P57F_570h',
              'WOS_P57F_570-2hh',
              'WOS_P57F_572ahh',
              'WOS_P57F_572bhh',
              'WOS_P57F_572chh',
              'WOS_P57F_572dhh',
              'WOS_P57F_572-2ahh',
              'WOS_P57F_572-2bhh',
              'WOS_P57F_572-2chh',
              'WOS_P57F_572-2dhh',
              'WOS_P57F_574ahh',
              'WOS_P57F_574bh',
              'WOS_P57F_574chh',
              'WOS_P57F_574dhh',
              'WOS_P57F_574-2ahh',
              'WOS_P57F_574-2bhh',
              'WOS_P57F_574-2chh',
              'WOS_P57F_574-2dhh',
              'WOS_P57F_576ahh',
              'WOS_P57F_576bhh',
              'WOS_P57F_576chh',
              'WOS_P57F_576-2ahh',
              'WOS_P57F_576-2bhh',
              'WOS_P57F_576-2chh',
              'WOS_P57F_578ahh',
              'WOS_P57F_578bhh',
              'WOS_P57F_578chh',
              'WOS_P57F_578-2ahh',
              'WOS_P57F_578-2bhh',
              'WOS_P57F_578-2chh',
              'WOS_P57F_580ahh',
              'WOS_P57F_580bhh',
              'WOS_P57F_580chh',
              'WOS_P57F_580dhh',
              'WOS_P57F_580ehh',
              'WOS_P57F_580-2ahh',
              'WOS_P57F_580-2bhh',
              'WOS_P57F_580-2chh',
              'WOS_P57F_580-2dhh',
              'WOS_P57F_580-2ehh',
              'WOS_P57F_582ahh',
              'WOS_P57F_582bhh',
              'WOS_P57F_582chh',
              'WOS_P57F_582dhh',
              'WOS_P57F_582-2ahh',
              'WOS_P57F_582-2bhh',
              'WOS_P57F_582-2chh',
              'WOS_P57F_582-2dhh',
              'WOS_P57F_584hh',
              'WOS_P57F_584-2hh',
              'WOS_P57F_586hh',
              'WOS_P57F_586-2hh',
              'WOS_P57F_588ahh',
              'WOS_P57F_588bhh',
              'WOS_P57F_588chh',
              'WOS_P57F_588dhh',
              'WOS_P57F_588-2ahh',
              'WOS_P57F_588-2bhh',
              'WOS_P57F_588-2chh',
              'WOS_P57F_588-2dhh',
              'WOS_P57F_598ahh',
              'WOS_P57F_598bhh',
              'WOS_P57F_598chh',
              'WOS_P57F_598dhh',
              'WOS_P57F_598-2ahh',
              'WOS_P57F_598-2bhh',
              'WOS_P57F_598-2chh',
              'WOS_P57F_598-2dhh',
              'WOS_P57F_600hh',
              'WOS_P57F_600-2hh',
              'WOS_P57F_602hh',
              'WOS_P57F_602-2hh',
              'WOS_P57F_604ahh',
              'WOS_P57F_604bhh',
              'WOS_P57F_604chh',
              'WOS_P57F_604dhh',
              'WOS_P57F_604-2ahh',
              'WOS_P57F_604-2bhh',
              'WOS_P57F_604-2chh',
              'WOS_P57F_604-2dhh',
              'WOS_P57F_606hh',
              'WOS_P57F_606-2hh',
              'WOS_P57F_608hh',
              'WOS_P57F_608-2hh',
              'WOS_P57F_590av',
              'WOS_P57F_590bv',
              'WOS_P57F_590cv',
              'WOS_P57F_590dv',
              'WOS_P57F_590-2av',
              'WOS_P57F_590-2bv',
              'WOS_P57F_590-2cv',
              'WOS_P57F_590-2dv',
              'WOS_P57F_592av',
              'WOS_P57F_592bv',
              'WOS_P57F_592cv',
              'WOS_P57F_592dv',
              'WOS_P57F_592-2av',
              'WOS_P57F_592-2bv',
              'WOS_P57F_592-2cv',
              'WOS_P57F_592-2dv',
              'WOS_P57F_594av',
              'WOS_P57F_594bv',
              'WOS_P57F_594cv',
              'WOS_P57F_594-2av',
              'WOS_P57F_594-2bv',
              'WOS_P57F_594-2cv',
              'WOS_P57F_596av',
              'WOS_P57F_596bv',
              'WOS_P57F_596cv',
              'WOS_P57F_596dv',
              'WOS_P57F_596-2av',
              'WOS_P57F_596-2bv',
              'WOS_P57F_596-2cv',
              'WOS_P57F_596-2dv',
              'WOS_P57F_610av',
              'WOS_P57F_610bv',
              'WOS_P57F_610cv',
              'WOS_P57F_610dv',
              'WOS_P57F_610-2av',
              'WOS_P57F_610-2bv',
              'WOS_P57F_610-2cv',
              'WOS_P57F_610-2dv',
              'WOS_P57F_612av',
              'WOS_P57F_612bv',
              'WOS_P57F_612cv',
              'WOS_P57F_612dv',
              'WOS_P57F_612ev',
              'WOS_P57F_612-2av',
              'WOS_P57F_612-2bv',
              'WOS_P57F_612-2cv',
              'WOS_P57F_612-2dv',
              'WOS_P57F_612-2ev',
              'WOS_P57F_614av',
              'WOS_P57F_614bv',
              'WOS_P57F_614cv',
              'WOS_P57F_614dv',
              'WOS_P57F_614ev',
              'WOS_P57F_614-2av',
              'WOS_P57F_614-2bv',
              'WOS_P57F_614-2cv',
              'WOS_P57F_614-2dv',
              'WOS_P57F_614-2ev',
              'WOS_P57F_616av',
              'WOS_P57F_616bv',
              'WOS_P57F_616cv',
              'WOS_P57F_616dv',
              'WOS_P57F_616ev',
              'WOS_P57F_616-2av',
              'WOS_P57F_616-2bv',
              'WOS_P57F_616-2cv',
              'WOS_P57F_616-2dv',
              'WOS_P57F_616-2ev',
            ],
          },
          {
            name: 'Multi Fold',
            description: 'See only multi-fold cards',
            products: [
              'P1218_455A4v',
              'WOS_P455A_F154',
              'WOS_P455A_F178',
              'WOS_P455A_F186',
              'WOS_P455A_F190',
              'WOS_P455A_F192',
              'WOS_P455A_F202',
              'WOS_P455A_F204',
              'WOS_P455A_F212',
              'WOS_P455A_F228',
              'WOS_P455A_F236',
              'WOS_P455A_F238',
              'WOS_P455A_F242',
              'WOS_P455A_F246',
              'P455A_250',
              'P455A_252',
              'P455A_254',
              'P455A_256',
              'P455A_258',
              'P455A_260',
              'P455A_262',
              'P455A_264',
              'P455A_266',
              'P455A_268',
              'P455A_270',
              'P455A_272',
              'P455A_274',
              'P1218_55TF',
              'WOS_P55T_F154',
              'WOS_P55T_F178',
              'WOS_P55T_F186',
              'WOS_P55T_F190',
              'WOS_P55T_F192',
              'WOS_P55T_F202',
              'WOS_P55T_F204',
              'WOS_P55T_F212',
              'WOS_P55T_F228',
              'WOS_P55T_F236',
              'WOS_P55T_F238',
              'WOS_P55T_F242',
              'WOS_P55T_F246',
              'P55T_250',
              'P55T_252',
              'P55T_254',
              'P55T_256',
              'P55T_258',
              'P55T_260',
              'P55T_262',
              'P55T_264',
              'P55T_266',
              'P55T_268',
              'P55T_270',
              'P55T_272',
              'P55T_274',
            ],
          },
          {
            name: 'Pop Out',
            description: 'See only pop out cards',
            products: [
              'PCE1218_57Ph_PopOut-Round',
              'WOS_PCE57P_F302v',
              'WOS_PCE57P_F312v',
              'WOS_PCE57P_F316v',
              'PCE1218_57Ph_PopOut-Scalloped',
              'WOS_PCE57P_F300v',
              'WOS_PCE57P_F304v',
              'WOS_PCE57P_F308v',
              'WOS_PCE57P_F324v',
              'PCE57P_332v',
              'PCE1218_57Ph_PopOut-Tapered',
              'WOS_PCE57P_F310v',
              'WOS_PCE57P_F314v',
              'WOS_PCE57P_F318v',
              'PCE57P_330v',
            ],
          },
        ],
      },
    ],
  },
};

export default CardsFilters;
